<template>
  <div>
    <div style="margin: 30px 0 5px 30px;border-radius: 5px; border: 1px solid #f1f1f1;">
      <div style="display: flex;  flex-direction: row; margin: 0px 0 0px 0px; padding: 10px 20px 10px 10px; border-bottom: 1px solid #f1f1f1; justify-content: space-between; align-items: center;">
        <div style="display: flex;  flex-direction: row;">
          <el-upload
            style="width: 110px;"
            ref="uploadxml"
            :http-request="toxsltex"
            :show-file-list="false"
            :file-list="fileList">
            <el-button type="success" slot="trigger" icon="el-icon-upload2" style="margin-left: 10px;" size="small" plain>导入XMLToXSLT</el-button>
          </el-upload>
        </div>
        <div>
          <el-button type="primary" icon="el-icon-download" style="margin-left: 10px;" @click="coverepstoimg" size="small" plain>转换EPSToImg</el-button>
          <el-button type="primary" icon="el-icon-download" style="margin-left: 10px;" @click="outpdf" size="small" plain>输出PDF</el-button>
          <el-button type="primary" icon="el-icon-download" style="margin-left: 10px;" @click="outhtml" size="small" plain>输出HTML</el-button>
        </div>
      </div>
      <div style="display: flex; flex-direction: row;  align-items: center; padding: 10px 20px 10px 20px;">
        <div>
          <span>选择模板</span>
          <el-button type="info" icon="el-icon-s-management" style="margin-left: 10px;" @click="changetwomod" size="small" plain>默认两列</el-button>
          <el-button type="info" icon="el-icon-s-management" style="margin-left: 10px;" @click="changetreemod" size="small" plain>横板三竖</el-button>
          <el-button type="info" icon="el-icon-s-management" style="margin-left: 10px;" @click="tqcode" size="small" plain>提取代码</el-button>
        </div>
      </div>
    </div>
    <div style="margin: 0px 0 5px 30px;min-height: 600px; display: flex; flex-direction: row; border-radius: 5px; border: 3px solid #f1f1f1;">
      <div style="width: 20%; min-height: 600px; border-right: 3px solid #f1f1f1;">
        <!--
        <vue-json-editor v-model="jsonData"></vue-json-editor>
        -->
        <el-tree
          :data="jsonData"
          :props="defaultProps"
          default-expand-all
          accordion
          @node-click="handleNodeClick">
        </el-tree>
      </div>
      <div style="width: 100%; min-height: 600px; padding: 10px;">
        <div style="width: 100%; display: flex; align-items: center;">
          <el-button type="info" icon="el-icon-s-operation" @click="rulemana" size="small" plain>规则管理</el-button>
          <el-button type="info" icon="el-icon-s-flag" style="margin-left: 10px;" @click="addbz" size="small" plain>标注</el-button>
          <el-button type="info" icon="el-icon-edit-outline" style="margin-left: 10px;" @click="savebz" size="small" plain>更新</el-button>
          <el-dialog title="规则管理" :visible.sync="ruleshow">
            <el-form  label-width="120px">
              <el-row class="querypanel">
                <el-col :span="12">
                  <el-form label-width="120px" label-position="left">
                    <el-form-item label="节点文案:">
                      <el-input v-model="ruletxt" placeholder="请输入标题"></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="12">
                  <el-form label-width="120px" label-position="left" style="margin-left: 20px;">
                    <el-form-item label="处理方式:">
                      <el-select v-model="opway" filterable placeholder="请选择处理方式" >
                        <el-option
                          v-for="item in waylist"
                          :key="item.id"
                          :label="item.value"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
              <el-button style="margin-top: 20px" @click="addrule">添加规则</el-button>
            </el-form>
            <div class="showpcinfo">
              <el-table
                stripe
                :data="ruledata"
                ref="multipleTable">
                <el-table-column
                  prop="pointtxt"
                  label="节点文案">
                </el-table-column>
                <el-table-column
                  prop="opway"
                  label="处理方式">
                </el-table-column>
              </el-table>
            </div>
          </el-dialog>
        </div>
        <el-tabs v-model="activeName" type="card" style="margin: 10px 40px 0 0px; padding: 0px;">
          <el-tab-pane label="原版" name="html" style="margin: 0 20px 0 20px">
            <div v-if="showEditInfo">
              <el-input v-model="edittextinfo" placeholder="请输入内容">
                <el-button @click="replacestr" slot="append" icon="el-icon-search">替换</el-button>
              </el-input>
            </div>
            <div ref="pdfContent" id="htmlOutput"></div>
          </el-tab-pane>
          <el-tab-pane label="修正后版式" name="htmledit" style="margin: 0 20px 0 20px">
            <div id="page-header">
              <h2>自定义页眉</h2>
            </div>
            <div ref="finoutContent" id="finoutContent"></div>
            <div id="page-footer">
              <p>版权所有 @ [硕祺网络科技]，[2024]</p>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>

</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import XmlViewer from 'vue-xml-viewer';
  import VueJsonEditor from 'vue-json-editor'
  import html2pdf from 'html2pdf.js'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'FTPro',
    components: {
      XmlViewer,
      VueJsonEditor
    },
    data () {
      return {
        activeName: 'html',
        showEditInfo: false,
        ruleshow: false,
        edittextinfo: '',
        ruletxt: '',
        waylist: [{
          id: 1,
          value: '删除'
        }],
        ruledata: [],
        opway: 1,
        fullscreenLoading: false,
        fileList: [],
        fileList1: [],
        fileList2: [],
        defaultProps: {
          children: 'children',
          label: 'title'
        },
        xmldata: '',
        jsonData: '',
        xmlData1: '<?xml version="1.0" encoding="UTF-8"?><root><element>Value1</element></root>',
        xmlContent: '',
        xsltContent: '',
        jsonData1: {
          'id': 'M0R089tocnzhvh',
          'manualtype': 'vh',
          'lang': 'zh',
          'vehicle_code': '916W',
          'dev_code': '125D',
          'lo_date': '202304',
          'scale': 'minor',
          'my': '23MY',
          'vehicle_type': 'hv',
          'body_type': 'hb',
          'model': 'AXAL52L-SNXMBC',
          'drive_train': 'ff',
          'brand': 'to',
          'period_from': '230203',
          'period_to': '999999',
          'pubno': '01999-0R078',
          'pubname': 'TOYOTA RAV4 HEV Owners Manual',
          'identify_code': 's-2',
          'om_style': '16style',
          'destination': 'cn',
          'revision': '0',
          'publish_date': '20230401',
          'production': 'ITP',
          'children': [{
            'chapter': {
              'id': 'ch02',
              'chapnum': '02',
              'chaptype': 'chapter',
              'publish_em': 'yes',
              'publish_pm': 'yes',
              'publish_fullpm': 'yes',
              'children': [{
                'title': {
                  'column': 'col',
                  'page': 'none',
                  'text': '车辆状态信息和指示灯',
                  'children': []
                }
              }, {
                'section': {
                  'id': 'ch02se01',
                  'secnum': '1',
                  'publish_em': 'yes',
                  'publish_pm': 'yes',
                  'publish_fullpm': 'yes',
                  'children': [{
                    'title': {
                      'column': 'col',
                      'page': 'none',
                      'text': '仪表盘',
                      'children': []
                    }
                  }, {
                    'subsection_attention': {
                      'id': 'ch02se010401',
                      'column': 'full',
                      'publish_em': 'yes',
                      'publish_pm': 'yes',
                      'publish_fullpm': 'yes',
                      'children': [{
                        'titlegroup': {
                          'tabletype': 'SubSection_title',
                          'width': '4.646in',
                          'children': [{
                            'titlegroupbody': {
                              'children': [{
                                'titlegrouprow': {
                                  'children': [{
                                    'titlegroupcell': {
                                      'children': [{
                                        'title': {
                                          'column': 'full',
                                          'page': 'none',
                                          'children': [{
                                            'indexmarker': {
                                              'marker': '警告灯和指示灯',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }, {
                        'overview': {
                          'id': 'ch02se0104010501',
                          'publish_em': 'yes',
                          'publish_pm': 'yes',
                          'publish_fullpm': 'yes',
                          'children': [{
                            'para': {
                              'column': 'full',
                              'page': 'none',
                              'children': [{
                                'paratable': {
                                  'tabletype': 'ParaTable',
                                  'width': '4.614in',
                                  'children': [{
                                    'paratablebody': {
                                      'children': [{
                                        'paratablerow': {
                                          'children': [{
                                            'paratablecell': {
                                              'children': [{
                                                'paratabletxt': {
                                                  'type': 'typeA',
                                                  'text': '仪表盘、中央仪表板及外后视镜上的警告灯和指示灯提示驾驶员车辆各系统的状态。',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }, {
                        'topic': {
                          'id': 'ch02se0104010503',
                          'column': 'col',
                          'page': 'none',
                          'publish_em': 'yes',
                          'publish_pm': 'yes',
                          'publish_fullpm': 'yes',
                          'children': [{
                            'titlegroup': {
                              'tabletype': 'Topic_title',
                              'width': '2.185in',
                              'children': [{
                                'titlegroupbody': {
                                  'children': [{
                                    'titlegrouprow': {
                                      'children': [{
                                        'titlegroupcell': {
                                          'children': [{
                                            'title': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '警告灯',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'om_body': {
                              'id': 'ch02se01040105030601',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '警告灯提示驾驶员所示车辆系统出现故障。',
                                  'children': []
                                }
                              }, {
                                'table': {
                                  'frame': 'none',
                                  'fontsize': '8.5',
                                  'pgwide': '0',
                                  'column': 'col',
                                  'colsep': '0',
                                  'rowsep': '0',
                                  'page': 'none',
                                  'children': [{
                                    'tgroup': {
                                      'cols': '3',
                                      'tabletype': 'FrameNone_A',
                                      'colsep': '0',
                                      'rowsep': '0',
                                      'children': [{
                                        'colspec': {
                                          'colnum': '1',
                                          'colname': '1',
                                          'colwidth': '0.591in',
                                          'colsep': '0',
                                          'children': []
                                        }
                                      }, {
                                        'colspec': {
                                          'colnum': '2',
                                          'colname': '2',
                                          'colwidth': '0.315in',
                                          'colsep': '0',
                                          'children': []
                                        }
                                      }, {
                                        'colspec': {
                                          'colnum': '3',
                                          'colname': '3',
                                          'colwidth': '1.319in',
                                          'colsep': '0',
                                          'children': []
                                        }
                                      }, {
                                        'tbody': {
                                          'children': [{
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942043a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'p': {
                                                          'column': 'col',
                                                          'page': 'none',
                                                          'text': '（红色）',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '制动系统警告灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*1',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020601',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942043a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'p': {
                                                          'column': 'col',
                                                          'page': 'none',
                                                          'text': '（黄色）',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '制动系统警告灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*1',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020602',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv0230001a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '充电系统警告灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*2',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020603',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9926013a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '冷却液高温警告灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*2',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020604',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942211b.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '混合动力系统过热警告灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*2',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020605',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9926014a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '发动机油压不足警告灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*2',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020606',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942226a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '牵引用蓄电池电量不足警告灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*2',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020607',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942039a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '故障指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*1',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020608',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942037a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': 'SRS 警告灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*1',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020609',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942050a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': 'ABS 警告灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*1',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020610',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942038a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'p': {
                                                          'column': 'col',
                                                          'page': 'none',
                                                          'text': '（红色/黄色）',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '电动转向系统警告灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*1',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020611',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942074a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'p': {
                                                          'column': 'col',
                                                          'page': 'none',
                                                          'text': '（闪烁或点亮）',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': 'PCS 警告灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*1',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020612',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942073a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'p': {
                                                          'column': 'col',
                                                          'page': 'none',
                                                          'text': '（橙色）',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': 'LTA 指示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020613',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv0230019a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '丰田驻车辅助传感器 OFF 指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*3',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020614',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942078a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': 'RCTA OFF 指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*1',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0504070503',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942053a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '打滑指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*1',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020616',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9926015a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '不当踏板操作警告灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*2',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020617',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942049a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'p': {
                                                          'column': 'col',
                                                          'page': 'none',
                                                          'text': '（闪烁）',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '制动保持工作指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*1',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020618',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942046a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'p': {
                                                          'column': 'col',
                                                          'page': 'none',
                                                          'text': '（闪烁）',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '驻车制动指示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020619',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942059a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '轮胎气压警告灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*1',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020620',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942054a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '低燃油油位警告灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020621',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942034a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '驾驶员和前排乘客座椅安全带提示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020622',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv0243050b.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '后排乘客座椅安全带提示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se02040305020623',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }, {
                                'footnote': {
                                  'type': 'other',
                                  'num': '1',
                                  'children': [{
                                    'p': {
                                      'column': 'col',
                                      'page': 'none',
                                      'text': '电源开关切换至 ON 时，这些灯点亮，表示正在进行系统检查。混合动力系统起动后或数秒后这些灯会熄灭。如果有灯不点亮或不熄灭，则某个系统可能存在故障。请联系丰田经销店等对车辆进行检查。',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'footnote': {
                                  'type': 'other',
                                  'num': '2',
                                  'children': [{
                                    'p': {
                                      'column': 'col',
                                      'page': 'none',
                                      'text': '该灯在多信息显示屏上点亮，同时显示信息。',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'footnote': {
                                  'type': 'other',
                                  'num': '3',
                                  'children': [{
                                    'p': {
                                      'column': 'col',
                                      'page': 'none',
                                      'text': '丰田驻车辅助传感器功能启用时，如果电源开关切换至 ON，丰田驻车辅助传感器 OFF 指示灯点亮。该灯将在几秒钟后熄灭。',
                                      'children': []
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'attention': {
                              'id': 'ch02se01040105030602',
                              'type': 'warning',
                              'column': 'col',
                              'page': 'none',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'attentiontbl': {
                                  'tabletype': 'WarningTable',
                                  'width': '2.224in',
                                  'children': [{
                                    'attentiontbl_body': {
                                      'children': [{
                                        'attentiontbl_body_row': {
                                          'children': [{
                                            'attention_body': {
                                              'children': [{
                                                'attention_mark': {
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }, {
                                        'attentiontbl_body_row': {
                                          'children': [{
                                            'attention_body': {
                                              'children': [{
                                                'attention_para': {
                                                  'id': 'ch02se010401050306020701',
                                                  'publish_em': 'yes',
                                                  'publish_pm': 'yes',
                                                  'publish_fullpm': 'yes',
                                                  'children': [{
                                                    'title': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '如果某个安全系统警告灯不点亮',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '如果起动混合动力系统时某个安全系统警告灯（如 ABS 和 SRS 警告灯）不点亮，则可能意味着这些系统无法在发生事故时提供保护，从而可能会导致严重伤亡。如果发生此情况，请立即联系丰田经销店等对车辆进行检查。',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }, {
                        'topic': {
                          'id': 'ch02se0104010504',
                          'column': 'col',
                          'page': 'none',
                          'publish_em': 'yes',
                          'publish_pm': 'yes',
                          'publish_fullpm': 'yes',
                          'children': [{
                            'titlegroup': {
                              'tabletype': 'Topic_title',
                              'width': '2.185in',
                              'children': [{
                                'titlegroupbody': {
                                  'children': [{
                                    'titlegrouprow': {
                                      'children': [{
                                        'titlegroupcell': {
                                          'children': [{
                                            'title': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '指示灯',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'om_body': {
                              'id': 'ch02se01040105040601',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '指示灯提示驾驶员车辆各系统的操作状态。',
                                  'children': []
                                }
                              }, {
                                'table': {
                                  'frame': 'none',
                                  'fontsize': '8.5',
                                  'pgwide': '0',
                                  'column': 'col',
                                  'colsep': '0',
                                  'rowsep': '0',
                                  'page': 'none',
                                  'children': [{
                                    'tgroup': {
                                      'cols': '3',
                                      'tabletype': 'FrameNone_A',
                                      'colsep': '0',
                                      'rowsep': '0',
                                      'children': [{
                                        'colspec': {
                                          'colnum': '1',
                                          'colname': '1',
                                          'colwidth': '0.591in',
                                          'colsep': '0',
                                          'children': []
                                        }
                                      }, {
                                        'colspec': {
                                          'colnum': '2',
                                          'colname': '2',
                                          'colwidth': '0.315in',
                                          'colsep': '0',
                                          'children': []
                                        }
                                      }, {
                                        'colspec': {
                                          'colnum': '3',
                                          'colname': '3',
                                          'colwidth': '1.319in',
                                          'colsep': '0',
                                          'children': []
                                        }
                                      }, {
                                        'tbody': {
                                          'children': [{
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942026a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '转向信号指示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se020404',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942030a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '尾灯指示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se030401',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942028a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '大灯远光指示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0304010503',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942029a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '自动远光指示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se030402',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942032a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '前雾灯指示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se030403',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942033a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '后雾灯指示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se030403',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv99sn035a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '智能进入和起动系统指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*1',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0204010502',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv0230017a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '巡航控制指示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0504040512',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942071a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '动态雷达巡航控制指示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0504040504',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942070a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '巡航控制“',
                                                      'children': [{
                                                        'function': {
                                                          'text': 'SET',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0504040504',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942073a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': 'LTA 指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*2',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se05040205030604',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'page only',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0504030505',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv0230019a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '丰田驻车辅助传感器 OFF 指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*3, 4',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0504060503',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942053a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'p': {
                                                          'column': 'col',
                                                          'page': 'none',
                                                          'text': '（闪烁）',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '打滑指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*5',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se050411050206120701',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942052a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': 'VSC OFF 指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*3, 5',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se050411050206120703',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942074a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': 'PCS 警告灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*3, 5',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0504020504',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942192a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': 'BSM 外后视镜指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*5, 6',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0504050503',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'page only',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0504070503',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9943001a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': 'BSM OFF 指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*3, 5',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0504050503',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942078a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': 'RCTA OFF 指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*3, 5',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0504070503',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942048a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '制动保持备用指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*5',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se020406',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942049a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '制动保持工作指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*5',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se020406',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942058a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '安全指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*7',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch01.xml#ch01se050401',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'page only',
                                                          'srcfile': 'M0R089tocnzhvhch01.xml#ch01se05040205020602',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942062a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '“',
                                                      'children': [{
                                                        'function': {
                                                          'text': 'READY',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0204010502',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv99sn036a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '外部温度低指示灯',
                                                      'children': [{
                                                        'sup': {
                                                          'text': '*8',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'refid': 'ch02se010402050206020703',
                                                          'type': 'P.page',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942066a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': 'EV 指示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch01.xml#ch01se040401050206060702',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942046a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '驻车制动指示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se020405',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942063b.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': 'EV 驱动模式指示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0204020502',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942065a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '环保驾驶模式指示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se050408',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942064a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '运动模式指示灯（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se050408',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'padding_top': '4',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942153b.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '1',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'namest': '2',
                                                  'nameend': '3',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '越野模式指示灯（如有配备）（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se050409',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }, {
                                'footnote': {
                                  'type': 'other',
                                  'num': '1',
                                  'children': [{
                                    'p': {
                                      'column': 'col',
                                      'page': 'none',
                                      'text': '该灯在多信息显示屏上点亮，同时显示信息。',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'footnote': {
                                  'type': 'other',
                                  'num': '2',
                                  'children': [{
                                    'p': {
                                      'column': 'col',
                                      'page': 'none',
                                      'text': '根据操作条件，该灯的颜色和点亮/闪烁状态会变化。',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'footnote': {
                                  'type': 'other',
                                  'num': '3',
                                  'children': [{
                                    'p': {
                                      'column': 'col',
                                      'page': 'none',
                                      'text': '系统关闭后，该灯点亮。',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'footnote': {
                                  'type': 'other',
                                  'num': '4',
                                  'children': [{
                                    'p': {
                                      'column': 'col',
                                      'page': 'none',
                                      'text': '丰田驻车辅助传感器功能启用时，如果电源开关切换至 ON，丰田驻车辅助传感器 OFF 指示灯点亮。该灯将在几秒钟后熄灭。',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'footnote': {
                                  'type': 'other',
                                  'num': '5',
                                  'children': [{
                                    'p': {
                                      'column': 'col',
                                      'page': 'none',
                                      'text': '电源开关切换至 ON 时，这些灯点亮，表示正在进行系统检查。混合动力系统起动后或数秒后这些灯会熄灭。如果这些灯不点亮或不熄灭，则某个系统可能存在故障。请联系丰田经销店等对车辆进行检查。',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'footnote': {
                                  'type': 'other',
                                  'num': '6',
                                  'children': [{
                                    'p': {
                                      'column': 'col',
                                      'page': 'none',
                                      'text': '该灯在外后视镜上点亮。',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'footnote': {
                                  'type': 'other',
                                  'num': '7',
                                  'children': [{
                                    'p': {
                                      'column': 'col',
                                      'page': 'none',
                                      'text': '该灯在顶置储物箱板上点亮。',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'footnote': {
                                  'type': 'other',
                                  'num': '8',
                                  'children': [{
                                    'p': {
                                      'column': 'col',
                                      'page': 'none',
                                      'text': '外部温度为约 3°C 或更低时，指示灯将闪烁约 10 秒，然后保持点亮。',
                                      'children': []
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }, {
                    'subsection_attention': {
                      'id': 'ch02se010402',
                      'column': 'full',
                      'publish_em': 'yes',
                      'publish_pm': 'yes',
                      'publish_fullpm': 'yes',
                      'children': [{
                        'titlegroup': {
                          'tabletype': 'SubSection_title',
                          'width': '4.646in',
                          'children': [{
                            'titlegroupbody': {
                              'children': [{
                                'titlegrouprow': {
                                  'children': [{
                                    'titlegroupcell': {
                                      'children': [{
                                        'title': {
                                          'column': 'full',
                                          'page': 'none',
                                          'children': [{
                                            'indexmarker': {
                                              'marker': '仪表',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }, {
                        'topic': {
                          'id': 'ch02se0104020502',
                          'column': 'full',
                          'page': 'none',
                          'publish_em': 'yes',
                          'publish_pm': 'yes',
                          'publish_fullpm': 'yes',
                          'children': [{
                            'titlegroup': {
                              'tabletype': 'Topic_title',
                              'width': '4.606in',
                              'children': [{
                                'titlegroupbody': {
                                  'children': [{
                                    'titlegrouprow': {
                                      'children': [{
                                        'titlegroupcell': {
                                          'children': [{
                                            'title': {
                                              'column': 'full',
                                              'page': 'none',
                                              'text': '仪表显示',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'om_body': {
                              'id': 'ch02se01040205020601',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'paraselect': {
                                  'children': [{
                                    'paraselectitem': {
                                      'children': [{
                                        'title': {
                                          'column': 'full',
                                          'page': 'none',
                                          'text': '不显示导航系统的地图时',
                                          'children': []
                                        }
                                      }, {
                                        'fig': {
                                          'column': 'full',
                                          'page': 'none',
                                          'publish_em': 'yes',
                                          'publish_pm': 'yes',
                                          'publish_fullpm': 'yes',
                                          'children': [{
                                            'image': {
                                              'href': '../image/zziv0242296b.eps',
                                              'width': '114mm',
                                              'height': '57mm',
                                              'border': '1',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'callout': {
                                              'type': 'illust',
                                              'startnumber': '1',
                                              'children': [{
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_a.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '混合动力系统指示仪',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'sup': {
                                                          'text': '*',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '显示混合动力系统输出功率或再生水平（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'refid': 'ch02se010402050206020702',
                                                          'type': 'P.page',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_b.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '外部温度（[rarr]',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'refid': 'ch02se010402050206020703',
                                                          'type': 'P.page',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_c.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '数字车速表',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '显示车速',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_d.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '时钟',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '利用 GPS 时间信息自动调节 GPS 时钟的时间。有关详情，请参见《',
                                                      'children': [{
                                                        'function': {
                                                          'text': '导航和多媒体系统用户手册',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_e.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '模拟车速表',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'sup': {
                                                          'text': '*',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '显示车速',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_f.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '里程表和短程里程表显示',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '里程表：',
                                                      'children': [{
                                                        'break': {
                                                          'type': 'return',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '短程里程表：',
                                                      'children': [{
                                                        'break': {
                                                          'type': 'return',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_g.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '多信息显示屏',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '向驾驶员提供各种与驾驶相关的数据（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'refid': 'ch02se010403',
                                                          'type': 'P.page',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '发生故障时显示警告信息（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se020404',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_h.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '燃油表',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '显示燃油箱中的剩余燃油量',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_i.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '档位和档域指示灯',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '显示所选档位或档域（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se020403',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }, {
                                        'footnote': {
                                          'type': 'other',
                                          'children': [{
                                            'p': {
                                              'column': 'full',
                                              'page': 'none',
                                              'text': '可关闭仪表。（[rarr]',
                                              'children': [{
                                                'xref': {
                                                  'refid': 'ch02se0104020504',
                                                  'type': 'P.page',
                                                  'ref_em': 'yes',
                                                  'ref_pm': 'yes',
                                                  'ref_fullpm': 'yes',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'paraselectitem': {
                                      'children': [{
                                        'title': {
                                          'column': 'full',
                                          'page': 'none',
                                          'text': '显示导航系统的地图时',
                                          'children': []
                                        }
                                      }, {
                                        'fig': {
                                          'column': 'full',
                                          'page': 'none',
                                          'publish_em': 'yes',
                                          'publish_pm': 'yes',
                                          'publish_fullpm': 'yes',
                                          'children': [{
                                            'image': {
                                              'href': '../image/zziv0242297a.eps',
                                              'width': '114mm',
                                              'height': '57mm',
                                              'border': '1',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'callout': {
                                              'type': 'illust',
                                              'startnumber': '1',
                                              'children': [{
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_a.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '外部温度（[rarr]',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'refid': 'ch02se010402050206020703',
                                                          'type': 'P.page',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_b.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '数字车速表',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '显示车速',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_c.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '时钟',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '利用 GPS 时间信息自动调节 GPS 时钟的时间。有关详情，请参见《',
                                                      'children': [{
                                                        'function': {
                                                          'text': '导航和多媒体系统用户手册',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_d.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '里程表和短程里程表显示',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '里程表：',
                                                      'children': [{
                                                        'break': {
                                                          'type': 'return',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '短程里程表：',
                                                      'children': [{
                                                        'break': {
                                                          'type': 'return',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_e.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '多信息显示屏',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '向驾驶员提供各种与驾驶相关的数据（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'refid': 'ch02se010403',
                                                          'type': 'P.page',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '发生故障时显示警告信息（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se020404',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_f.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '燃油表',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '显示燃油箱中的剩余燃油量',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_g.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '档位和档域指示灯',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'full',
                                                      'page': 'none',
                                                      'text': '显示所选档位或档域（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch04.xml#ch04se020403',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'note': {
                              'id': 'ch02se01040205020602',
                              'column': 'col',
                              'page': 'none',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'note_body': {
                                  'children': [{
                                    'note_para': {
                                      'id': 'ch02se010402050206020701',
                                      'publish_em': 'yes',
                                      'publish_pm': 'yes',
                                      'publish_fullpm': 'yes',
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '仪表和显示屏的点亮条件',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '电源开关置于 ON。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'attention': {
                              'id': 'ch02se01040205020603',
                              'type': 'warning',
                              'column': 'col',
                              'page': 'none',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'attentiontbl': {
                                  'tabletype': 'WarningTable',
                                  'width': '2.224in',
                                  'children': [{
                                    'attentiontbl_body': {
                                      'children': [{
                                        'attentiontbl_body_row': {
                                          'children': [{
                                            'attention_body': {
                                              'children': [{
                                                'attention_mark': {
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }, {
                                        'attentiontbl_body_row': {
                                          'children': [{
                                            'attention_body': {
                                              'children': [{
                                                'attention_para': {
                                                  'id': 'ch02se010402050206030701',
                                                  'publish_em': 'yes',
                                                  'publish_pm': 'yes',
                                                  'publish_fullpm': 'yes',
                                                  'children': [{
                                                    'title': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '低温下的信息显示',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '使用液晶信息显示屏前，先将车内升温。在极低温度下，显示屏监控器可能反应迟缓，显示内容的切换可能会延迟。',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '例如，显示屏显示的新档域滞后于驾驶员的换档操作。这一滞后可能导致驾驶员再次降档，造成发动机过快过度制动，并且可能引发事故从而造成伤亡。',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'attention': {
                              'id': 'ch02se01040205020604',
                              'type': 'notice',
                              'column': 'col',
                              'page': 'none',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'attentiontbl': {
                                  'tabletype': 'CautionTable',
                                  'width': '2.224in',
                                  'children': [{
                                    'attentiontbl_body': {
                                      'children': [{
                                        'attentiontbl_body_row': {
                                          'children': [{
                                            'attention_body': {
                                              'children': [{
                                                'attention_mark': {
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }, {
                                        'attentiontbl_body_row': {
                                          'children': [{
                                            'attention_body': {
                                              'children': [{
                                                'attention_para': {
                                                  'id': 'ch02se010402050206040701',
                                                  'publish_em': 'yes',
                                                  'publish_pm': 'yes',
                                                  'publish_fullpm': 'yes',
                                                  'children': [{
                                                    'title': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '防止损坏发动机及其部件',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '如果多信息显示屏上显示“',
                                                      'children': [{
                                                        'function': {
                                                          'text': '发动机冷却液 温度高 请在安全的地方 停车 请参见用户手册',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'type': 'P.page',
                                                          'srcfile': 'M0R089tocnzhvhch07.xml#ch07se020411',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }, {
                    'subsection_operation': {
                      'id': 'ch02se010403',
                      'column': 'col',
                      'publish_em': 'yes',
                      'publish_pm': 'yes',
                      'publish_fullpm': 'yes',
                      'children': [{
                        'titlegroup': {
                          'tabletype': 'SubSection_title',
                          'width': '2.224in',
                          'children': [{
                            'titlegroupbody': {
                              'children': [{
                                'titlegrouprow': {
                                  'children': [{
                                    'titlegroupcell': {
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'children': [{
                                            'indexmarker': {
                                              'marker': '多信息显示屏',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }, {
                        'topic_function_basic': {
                          'id': 'ch02se0104030502',
                          'column': 'col',
                          'page': 'none',
                          'publish_em': 'yes',
                          'publish_pm': 'yes',
                          'publish_fullpm': 'yes',
                          'children': [{
                            'titlegroup': {
                              'tabletype': 'Topic_title',
                              'width': '2.185in',
                              'children': [{
                                'titlegroupbody': {
                                  'children': [{
                                    'titlegrouprow': {
                                      'children': [{
                                        'titlegroupcell': {
                                          'children': [{
                                            'title': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '显示内容',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'basic_description': {
                              'id': 'ch02se01040305020601',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '多信息显示屏上显示以下信息。',
                                  'children': []
                                }
                              }, {
                                'paraselect': {
                                  'children': [{
                                    'paraselectitem': {
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '不显示导航系统的地图时',
                                          'children': []
                                        }
                                      }, {
                                        'fig': {
                                          'column': 'col',
                                          'page': 'none',
                                          'publish_em': 'yes',
                                          'publish_pm': 'yes',
                                          'publish_fullpm': 'yes',
                                          'children': [{
                                            'image': {
                                              'href': '../image/zziv0242299a.eps',
                                              'width': '56mm',
                                              'height': '57mm',
                                              'border': '1',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'callout': {
                                              'type': 'illust',
                                              'startnumber': '1',
                                              'children': [{
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_a.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '菜单图标（[rarr]',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'refid': 'ch02se0104030504',
                                                          'type': 'P.page',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_b.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '信息显示区域',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '通过选择菜单图标可显示各种信息。',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '此外，在某些情况下，还会显示警告或建议/提议弹出式显示。',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_c.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '驾驶辅助系统状态显示区域',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '下列系统正在操作以及选择了',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../image/zziv9942173a.eps',
                                                          'width': '8.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'calloutlist': {
                                                      'column': 'col',
                                                      'children': [{
                                                        'calloutlist_item': {
                                                          'children': [{
                                                            'itemtxt': {
                                                              'page': 'none',
                                                              'text': 'LTA（车道跟踪辅助）（[rarr]',
                                                              'children': [{
                                                                'xref': {
                                                                  'type': 'P.page',
                                                                  'srcfile': 'M0R089tocnzhvhch04.xml#ch04se050403',
                                                                  'ref_em': 'yes',
                                                                  'ref_pm': 'yes',
                                                                  'ref_fullpm': 'yes',
                                                                  'children': []
                                                                }
                                                              }]
                                                            }
                                                          }]
                                                        }
                                                      }, {
                                                        'calloutlist_item': {
                                                          'children': [{
                                                            'itemtxt': {
                                                              'page': 'none',
                                                              'text': '全速动态雷达巡航控制（[rarr]',
                                                              'children': [{
                                                                'xref': {
                                                                  'type': 'P.page',
                                                                  'srcfile': 'M0R089tocnzhvhch04.xml#ch04se050404',
                                                                  'ref_em': 'yes',
                                                                  'ref_pm': 'yes',
                                                                  'ref_fullpm': 'yes',
                                                                  'children': []
                                                                }
                                                              }]
                                                            }
                                                          }]
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'paraselectitem': {
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '显示导航系统的地图时',
                                          'children': []
                                        }
                                      }, {
                                        'fig': {
                                          'column': 'col',
                                          'page': 'none',
                                          'publish_em': 'yes',
                                          'publish_pm': 'yes',
                                          'publish_fullpm': 'yes',
                                          'children': [{
                                            'image': {
                                              'href': '../image/zziv0242300a.eps',
                                              'width': '56mm',
                                              'height': '57mm',
                                              'border': '1',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'callout': {
                                              'type': 'illust',
                                              'startnumber': '1',
                                              'children': [{
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_a.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '菜单图标（[rarr]',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'xref': {
                                                          'refid': 'ch02se0104030504',
                                                          'type': 'P.page',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_b.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '驾驶辅助系统状态显示区域',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '下列系统正在操作以及选择了',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../image/zziv9942173a.eps',
                                                          'width': '8.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'calloutlist': {
                                                      'column': 'col',
                                                      'children': [{
                                                        'calloutlist_item': {
                                                          'children': [{
                                                            'itemtxt': {
                                                              'page': 'none',
                                                              'text': 'LTA（车道跟踪辅助）（[rarr]',
                                                              'children': [{
                                                                'xref': {
                                                                  'type': 'P.page',
                                                                  'srcfile': 'M0R089tocnzhvhch04.xml#ch04se050403',
                                                                  'ref_em': 'yes',
                                                                  'ref_pm': 'yes',
                                                                  'ref_fullpm': 'yes',
                                                                  'children': []
                                                                }
                                                              }]
                                                            }
                                                          }]
                                                        }
                                                      }, {
                                                        'calloutlist_item': {
                                                          'children': [{
                                                            'itemtxt': {
                                                              'page': 'none',
                                                              'text': '全速动态雷达巡航控制（[rarr]',
                                                              'children': [{
                                                                'xref': {
                                                                  'type': 'P.page',
                                                                  'srcfile': 'M0R089tocnzhvhch04.xml#ch04se050404',
                                                                  'ref_em': 'yes',
                                                                  'ref_pm': 'yes',
                                                                  'ref_fullpm': 'yes',
                                                                  'children': []
                                                                }
                                                              }]
                                                            }
                                                          }]
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_c.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '信息显示区域',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '通过选择菜单图标可显示各种信息。',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'callouttxt_sub': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '此外，在某些情况下，还会显示警告或建议/提议弹出式显示。',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_d.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '导航系统相关显示区域',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'note': {
                              'id': 'ch02se01040305020602',
                              'column': 'col',
                              'page': 'none',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'note_body': {
                                  'children': [{
                                    'note_para': {
                                      'id': 'ch02se010403050206020701',
                                      'publish_em': 'yes',
                                      'publish_pm': 'yes',
                                      'publish_fullpm': 'yes',
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '多信息显示屏的显示条件',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '电源开关置于 ON。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'note_para': {
                                      'id': 'ch02se010403050206020702',
                                      'publish_em': 'yes',
                                      'publish_pm': 'yes',
                                      'publish_fullpm': 'yes',
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '切换为正常模式以外的其他驾驶模式时',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '[rarr]',
                                          'children': [{
                                            'xref': {
                                              'type': 'P.page',
                                              'srcfile': 'M0R089tocnzhvhch04.xml#ch04se050408',
                                              'ref_em': 'yes',
                                              'ref_pm': 'yes',
                                              'ref_fullpm': 'yes',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'note_para': {
                                      'id': 'ch02se010403050206020703',
                                      'publish_em': 'yes',
                                      'publish_pm': 'yes',
                                      'publish_fullpm': 'yes',
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '液晶显示屏',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '显示屏上可能出现小点或亮点。这是液晶显示屏的特点，并不是故障，请继续使用。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }, {
                        'topic_function_basic': {
                          'id': 'ch02se0104030503',
                          'column': 'col',
                          'page': 'none',
                          'publish_em': 'yes',
                          'publish_pm': 'yes',
                          'publish_fullpm': 'yes',
                          'children': [{
                            'titlegroup': {
                              'tabletype': 'Topic_title',
                              'width': '2.185in',
                              'children': [{
                                'titlegroupbody': {
                                  'children': [{
                                    'titlegrouprow': {
                                      'children': [{
                                        'titlegroupcell': {
                                          'children': [{
                                            'title': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '切换显示',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'attention': {
                              'id': 'ch02se01040305030602',
                              'type': 'warning',
                              'column': 'col',
                              'page': 'none',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'attentiontbl': {
                                  'tabletype': 'WarningTable',
                                  'width': '2.224in',
                                  'children': [{
                                    'attentiontbl_body': {
                                      'children': [{
                                        'attentiontbl_body_row': {
                                          'children': [{
                                            'attention_body': {
                                              'children': [{
                                                'attention_mark': {
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }, {
                                        'attentiontbl_body_row': {
                                          'children': [{
                                            'attention_body': {
                                              'children': [{
                                                'attention_para': {
                                                  'id': 'ch02se010403050306020701',
                                                  'publish_em': 'yes',
                                                  'publish_pm': 'yes',
                                                  'publish_fullpm': 'yes',
                                                  'children': [{
                                                    'title': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '驾驶中使用时的注意事项',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '为安全起见，驾驶时尽量避免操作仪表控制开关，也不要在驾驶时持续查看多信息显示屏。请停车，然后操作仪表控制开关。否则可能造成方向盘操作错误，从而导致意外事故。',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }, {
                        'topic_function_basic': {
                          'id': 'ch02se0104030504',
                          'column': 'col',
                          'page': 'none',
                          'publish_em': 'yes',
                          'publish_pm': 'yes',
                          'publish_fullpm': 'yes',
                          'children': [{
                            'titlegroup': {
                              'tabletype': 'Topic_title',
                              'width': '2.185in',
                              'children': [{
                                'titlegroupbody': {
                                  'children': [{
                                    'titlegrouprow': {
                                      'children': [{
                                        'titlegroupcell': {
                                          'children': [{
                                            'title': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '菜单图标',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'basic_operation': {
                              'id': 'ch02se01040305040601',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '使用仪表控制开关选择任一图标可显示与该图标相关的信息。',
                                  'children': []
                                }
                              }, {
                                'p_sub': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '根据不同情况，可能自动显示某些信息。',
                                  'children': []
                                }
                              }, {
                                'table': {
                                  'frame': 'all',
                                  'fontsize': '8.5',
                                  'pgwide': '0',
                                  'column': 'col',
                                  'colsep': '1',
                                  'rowsep': '1',
                                  'page': 'none',
                                  'children': [{
                                    'tgroup': {
                                      'cols': '2',
                                      'tabletype': 'FrameAll',
                                      'colsep': '1',
                                      'rowsep': '1',
                                      'children': [{
                                        'colspec': {
                                          'colnum': '1',
                                          'colname': '1',
                                          'colwidth': '0.591in',
                                          'children': []
                                        }
                                      }, {
                                        'colspec': {
                                          'colnum': '2',
                                          'colname': '2',
                                          'colwidth': '1.634in',
                                          'children': []
                                        }
                                      }, {
                                        'thead': {
                                          'children': [{
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '图标',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'colname': '2',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '显示',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }, {
                                        'tbody': {
                                          'children': [{
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'valign': 'middle',
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942156a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '0',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'valign': 'middle',
                                                  'colname': '2',
                                                  'fontwidth': 'normal',
                                                  'padding_left': '4',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '驾驶信息显示（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'refid': 'ch02se0104030505',
                                                          'type': 'P.page',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'valign': 'middle',
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942157a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '0',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'valign': 'middle',
                                                  'colname': '2',
                                                  'fontwidth': 'normal',
                                                  'padding_left': '4',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '驾驶辅助系统信息显示（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'refid': 'ch02se0104030506',
                                                          'type': 'P.page',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'valign': 'middle',
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942158a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '0',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'valign': 'middle',
                                                  'colname': '2',
                                                  'fontwidth': 'normal',
                                                  'padding_left': '4',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '音响系统相关显示（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'refid': 'ch02se0104030507',
                                                          'type': 'P.page',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'valign': 'middle',
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942159a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '0',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'valign': 'middle',
                                                  'colname': '2',
                                                  'fontwidth': 'normal',
                                                  'padding_left': '4',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '车辆信息显示（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'refid': 'ch02se0104030508',
                                                          'type': 'P.page',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'valign': 'middle',
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942160a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '0',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'valign': 'middle',
                                                  'colname': '2',
                                                  'fontwidth': 'normal',
                                                  'padding_left': '4',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '设定显示（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'refid': 'ch02se0104030509',
                                                          'type': 'P.page',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'row': {
                                              'children': [{
                                                'entry': {
                                                  'valign': 'middle',
                                                  'colname': '1',
                                                  'fontwidth': 'normal',
                                                  'children': [{
                                                    'tbl_fig': {
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'image': {
                                                          'href': '../image/zziv9942161a.eps',
                                                          'width': '12mm',
                                                          'height': '8mm',
                                                          'border': '0',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.000mm',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'entry': {
                                                  'align': 'left',
                                                  'valign': 'middle',
                                                  'colname': '2',
                                                  'fontwidth': 'normal',
                                                  'padding_left': '4',
                                                  'children': [{
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '警告信息显示（[rarr]',
                                                      'children': [{
                                                        'xref': {
                                                          'refid': 'ch02se0104030510',
                                                          'type': 'P.page',
                                                          'ref_em': 'yes',
                                                          'ref_pm': 'yes',
                                                          'ref_fullpm': 'yes',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }, {
                        'topic_function_basic': {
                          'id': 'ch02se0104030505',
                          'column': 'col',
                          'page': 'none',
                          'publish_em': 'yes',
                          'publish_pm': 'yes',
                          'publish_fullpm': 'yes',
                          'children': [{
                            'titlegroup': {
                              'tabletype': 'Topic_title',
                              'width': '2.185in',
                              'children': [{
                                'titlegroupbody': {
                                  'children': [{
                                    'titlegrouprow': {
                                      'children': [{
                                        'titlegroupcell': {
                                          'children': [{
                                            'title': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '驾驶信息显示',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'basic_operation': {
                              'id': 'ch02se01040305050601',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '选择可显示各种格式的油耗数据。',
                                  'children': []
                                }
                              }]
                            }
                          }, {
                            'note': {
                              'id': 'ch02se01040305050605',
                              'column': 'col',
                              'page': 'none',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'note_body': {
                                  'children': [{
                                    'note_para': {
                                      'id': 'ch02se010403050506050701',
                                      'publish_em': 'yes',
                                      'publish_pm': 'yes',
                                      'publish_fullpm': 'yes',
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '燃油耗尽前最远行驶里程',
                                          'children': []
                                        }
                                      }, {
                                        'att_list1': {
                                          'type': 'bull',
                                          'column': 'col',
                                          'children': [{
                                            'att_list1_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '该里程是根据平均油耗计算所得。因此，可行驶的实际里程可能会与显示的里程有所不同。',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'att_list1_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '仅向燃油箱加注少量燃油时，显示可能不会更新。加油时，关闭电源开关。如果在未关闭电源开关的情况下给车辆加油，则显示可能不会更新。',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'att_list1_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '显示“',
                                                  'children': [{
                                                    'function': {
                                                      'text': '请加油',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'break': {
                                                      'type': 'return',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }, {
                        'topic_function_basic': {
                          'id': 'ch02se0104030509',
                          'column': 'col',
                          'page': 'none',
                          'publish_em': 'yes',
                          'publish_pm': 'yes',
                          'publish_fullpm': 'yes',
                          'children': [{
                            'titlegroup': {
                              'tabletype': 'Topic_title',
                              'width': '2.185in',
                              'children': [{
                                'titlegroupbody': {
                                  'children': [{
                                    'titlegrouprow': {
                                      'children': [{
                                        'titlegroupcell': {
                                          'children': [{
                                            'title': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '设定显示',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'body': {
                              'children': [{
                                'p': {
                                  'text': '具体内容请参考用户手册电子版。',
                                  'children': []
                                }
                              }]
                            }
                          }, {
                            'basic_operation': {
                              'id': 'ch02se01040305090602',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'title': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '设定步骤',
                                  'children': []
                                }
                              }, {
                                'step': {
                                  'column': 'col',
                                  'startnumber': '1',
                                  'children': [{
                                    'stepitem': {
                                      'column': 'col',
                                      'children': [{
                                        'steptxt': {
                                          'num': 'num',
                                          'page': 'none',
                                          'text': '操作仪表控制开关的',
                                          'children': [{
                                            'symbol': {
                                              'href': '../image/zziv9942021a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'symbol': {
                                              'href': '../image/zziv9942019a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'symbol': {
                                              'href': '../image/zziv9942176a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'stepitem': {
                                      'column': 'col',
                                      'children': [{
                                        'steptxt': {
                                          'num': 'num',
                                          'page': 'none',
                                          'text': '操作仪表控制开关的',
                                          'children': [{
                                            'symbol': {
                                              'href': '../image/zziv9942018a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'symbol': {
                                              'href': '../image/zziv9942020a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'list1': {
                                          'type': 'dot',
                                          'column': 'col',
                                          'children': [{
                                            'list1_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '如果在设定画面上启用和关闭该功能或更改音量等，则每次按下',
                                                  'children': [{
                                                    'symbol': {
                                                      'href': '../image/zziv9942023a.eps',
                                                      'width': '5.000mm',
                                                      'height': '5.000mm',
                                                      'xoffset': '0.000mm',
                                                      'yoffset': '0.000mm',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'list1_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '对于可选择其操作内容、显示内容等的功能，按住',
                                                  'children': [{
                                                    'symbol': {
                                                      'href': '../image/zziv9942023a.eps',
                                                      'width': '5.000mm',
                                                      'height': '5.000mm',
                                                      'xoffset': '0.000mm',
                                                      'yoffset': '0.000mm',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'symbol': {
                                                      'href': '../image/zziv9942023a.eps',
                                                      'width': '5.000mm',
                                                      'height': '5.000mm',
                                                      'xoffset': '0.000mm',
                                                      'yoffset': '0.000mm',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'stepitem': {
                                      'column': 'col',
                                      'children': [{
                                        'steptxt': {
                                          'num': 'num',
                                          'page': 'none',
                                          'text': '更改设定后，按下仪表控制开关的',
                                          'children': [{
                                            'symbol': {
                                              'href': '../image/zziv9942022a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'basic_operation': {
                              'id': 'ch02se01040305090603',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'title': {
                                  'column': 'col',
                                  'page': 'none',
                                  'children': [{
                                    'symbol': {
                                      'href': '../image/zziv9942178a.eps',
                                      'width': '5.000mm',
                                      'height': '5.000mm',
                                      'xoffset': '0.000mm',
                                      'yoffset': '0.000mm',
                                      'children': []
                                    }
                                  }, {
                                    'xref': {
                                      'type': 'P.page',
                                      'srcfile': 'M0R089tocnzhvhch04.xml#ch04se050403',
                                      'ref_em': 'yes',
                                      'ref_pm': 'yes',
                                      'ref_fullpm': 'yes',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '选择可设定以下项目。',
                                  'children': []
                                }
                              }, {
                                'list1': {
                                  'type': 'bull',
                                  'column': 'col',
                                  'children': [{
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '中线追踪',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可启用/禁用车道居中功能。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '灵敏度',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可设定车道偏离警示灵敏度。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '摇摆警告',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可启用/禁用车辆摇晃警告。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '摇摆灵敏度',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可设定车辆摇晃警告灵敏度。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'basic_description': {
                              'id': 'ch02se01040305090604',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'title': {
                                  'column': 'col',
                                  'page': 'none',
                                  'children': [{
                                    'symbol': {
                                      'href': '../image/zziv9942179a.eps',
                                      'width': '6.000mm',
                                      'height': '5.000mm',
                                      'xoffset': '0.000mm',
                                      'yoffset': '0.000mm',
                                      'children': []
                                    }
                                  }, {
                                    'xref': {
                                      'type': 'P.page',
                                      'srcfile': 'M0R089tocnzhvhch04.xml#ch04se050402',
                                      'ref_em': 'yes',
                                      'ref_pm': 'yes',
                                      'ref_fullpm': 'yes',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '选择可设定以下项目。',
                                  'children': []
                                }
                              }, {
                                'list1': {
                                  'type': 'bull',
                                  'column': 'col',
                                  'children': [{
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': 'PCS 打开/关闭',
                                          'children': []
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可启用/禁用碰撞预测系统。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '灵敏度',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可更改碰撞预测警告时机。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'basic_operation': {
                              'id': 'ch02se01040305090605',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'title': {
                                  'column': 'col',
                                  'page': 'none',
                                  'children': [{
                                    'symbol': {
                                      'href': '../image/zziv9930027a.eps',
                                      'width': '8.000mm',
                                      'height': '5.000mm',
                                      'xoffset': '0.000mm',
                                      'yoffset': '0.000mm',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '选择可设定以下项目。',
                                  'children': []
                                }
                              }, {
                                'list1': {
                                  'type': 'bull',
                                  'column': 'col',
                                  'children': [{
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '转弯减速控制',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }, {
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '选择可更改弯道减速功能的设定。（[rarr]',
                                  'children': [{
                                    'xref': {
                                      'type': 'P.page',
                                      'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0504040511',
                                      'ref_em': 'yes',
                                      'ref_pm': 'yes',
                                      'ref_fullpm': 'yes',
                                      'children': []
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'basic_operation': {
                              'id': 'ch02se01040305090606',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'title': {
                                  'column': 'col',
                                  'page': 'none',
                                  'children': [{
                                    'symbol': {
                                      'href': '../image/zziv9942180a.eps',
                                      'width': '8.000mm',
                                      'height': '5.000mm',
                                      'xoffset': '0.000mm',
                                      'yoffset': '0.000mm',
                                      'children': []
                                    }
                                  }, {
                                    'xref': {
                                      'type': 'P.page',
                                      'srcfile': 'M0R089tocnzhvhch04.xml#ch04se050405',
                                      'ref_em': 'yes',
                                      'ref_pm': 'yes',
                                      'ref_fullpm': 'yes',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '选择可设定以下项目。',
                                  'children': []
                                }
                              }, {
                                'list1': {
                                  'type': 'bull',
                                  'column': 'col',
                                  'children': [{
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': 'BSM（盲点监控器）打开/关闭',
                                          'children': []
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可启用/禁用 BSM 系统。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '亮度',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可切换外后视镜指示灯的亮度。（[rarr]',
                                          'children': [{
                                            'xref': {
                                              'type': 'P.page',
                                              'srcfile': 'M0R089tocnzhvhch04.xml#ch04se0504050503',
                                              'ref_em': 'yes',
                                              'ref_pm': 'yes',
                                              'ref_fullpm': 'yes',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '灵敏度',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可更改检测到接近车辆时的警告时机。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'basic_description': {
                              'id': 'ch02se01040305090607',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'title': {
                                  'column': 'col',
                                  'page': 'none',
                                  'children': [{
                                    'symbol': {
                                      'href': '../image/zziv9942181a.eps',
                                      'width': '9.000mm',
                                      'height': '5.000mm',
                                      'xoffset': '0.000mm',
                                      'yoffset': '0.000mm',
                                      'children': []
                                    }
                                  }, {
                                    'xref': {
                                      'type': 'P.page',
                                      'srcfile': 'M0R089tocnzhvhch04.xml#ch04se050406',
                                      'ref_em': 'yes',
                                      'ref_pm': 'yes',
                                      'ref_fullpm': 'yes',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '选择可设定以下项目。',
                                  'children': []
                                }
                              }, {
                                'list1': {
                                  'type': 'bull',
                                  'column': 'col',
                                  'children': [{
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '丰田驻车辅助传感器打开/关闭',
                                          'children': []
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可启用/禁用丰田驻车辅助传感器。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '音量',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可设定丰田驻车辅助传感器操作时鸣响的蜂鸣器音量。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'basic_description': {
                              'id': 'ch02se01040305090608',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'title': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': 'RCTA（倒车侧后方盲点警示）（如有配备）（[rarr]',
                                  'children': [{
                                    'xref': {
                                      'type': 'P.page',
                                      'srcfile': 'M0R089tocnzhvhch04.xml#ch04se050407',
                                      'ref_em': 'yes',
                                      'ref_pm': 'yes',
                                      'ref_fullpm': 'yes',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'list1': {
                                  'type': 'bull',
                                  'column': 'col',
                                  'children': [{
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': 'RCTA（倒车侧后方盲点警示功能）打开/关闭',
                                          'children': []
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可启用/禁用 RCTA 系统。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '音量',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可更改 RCTA 蜂鸣器音量。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'basic_description': {
                              'id': 'ch02se01040305090609',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'title': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': 'HUD（平视显示器）（如有配备）（[rarr]',
                                  'children': [{
                                    'xref': {
                                      'refid': 'ch02se010404',
                                      'type': 'P.page',
                                      'ref_em': 'yes',
                                      'ref_pm': 'yes',
                                      'ref_fullpm': 'yes',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '选择可更改平视显示器设定。',
                                  'children': []
                                }
                              }]
                            }
                          }, {
                            'basic_description': {
                              'id': 'ch02se01040305090610',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'title': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '仪表盘亮度',
                                  'children': []
                                }
                              }, {
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '选择可调节仪表盘照明灯的亮度。',
                                  'children': []
                                }
                              }]
                            }
                          }, {
                            'basic_operation': {
                              'id': 'ch02se01040305090611',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'title': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '车辆设定',
                                  'children': []
                                }
                              }, {
                                'list1': {
                                  'type': 'bull',
                                  'column': 'col',
                                  'children': [{
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'children': [{
                                            'symbol': {
                                              'href': '../image/zziv9948028a.eps',
                                              'width': '8.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'xref': {
                                              'type': 'P.page',
                                              'srcfile': 'M0R089tocnzhvhch03.xml#ch03se0204020506',
                                              'ref_em': 'yes',
                                              'ref_pm': 'yes',
                                              'ref_fullpm': 'yes',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可设定以下项目。',
                                          'children': []
                                        }
                                      }, {
                                        'list2': {
                                          'type': 'dot',
                                          'children': [{
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '系统设定',
                                                  'children': []
                                                }
                                              }, {
                                                'itemtxt_sub': {
                                                  'page': 'none',
                                                  'text': '选择可启用/禁用电动背门系统。',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '“',
                                                  'children': [{
                                                    'function': {
                                                      'text': '免用双手',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'itemtxt_sub': {
                                                  'page': 'none',
                                                  'text': '选择可启用/禁用脚踢感应电动背门操作。',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '“',
                                                  'children': [{
                                                    'function': {
                                                      'text': '开度调整',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'itemtxt_sub': {
                                                  'page': 'none',
                                                  'text': '选择电动背门全开时的打开位置。',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '“',
                                                  'children': [{
                                                    'function': {
                                                      'text': '音量',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'itemtxt_sub': {
                                                  'page': 'none',
                                                  'text': '选择可设定电动背门系统操作时鸣响的蜂鸣器音量。',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }, {
                                'list1': {
                                  'type': 'bull',
                                  'column': 'col',
                                  'children': [{
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': 'TPWS',
                                              'children': []
                                            }
                                          }, {
                                            'xref': {
                                              'type': 'P.page',
                                              'srcfile': 'M0R089tocnzhvhch06.xml#ch06se0304060504',
                                              'ref_em': 'yes',
                                              'ref_pm': 'yes',
                                              'ref_fullpm': 'yes',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'list2': {
                                          'type': 'dot',
                                          'children': [{
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '“',
                                                  'children': [{
                                                    'function': {
                                                      'text': '设置轮胎气压',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'itemtxt_sub': {
                                                  'page': 'none',
                                                  'text': '选择可初始化轮胎气压警告系统。',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '“',
                                                  'children': [{
                                                    'function': {
                                                      'text': '变更轮组',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'itemtxt_sub': {
                                                  'page': 'none',
                                                  'text': '选择可将轮胎气压传感器的 ID 代码注册至轮胎气压警告系统。',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '后座提醒',
                                              'children': []
                                            }
                                          }, {
                                            'xref': {
                                              'type': 'P.page',
                                              'srcfile': 'M0R089tocnzhvhch03.xml#ch03se020401050206030710',
                                              'ref_em': 'yes',
                                              'ref_pm': 'yes',
                                              'ref_fullpm': 'yes',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可启用/禁用后排座椅提示功能。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'basic_operation': {
                              'id': 'ch02se01040305090612',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'title': {
                                  'column': 'col',
                                  'page': 'none',
                                  'children': [{
                                    'symbol': {
                                      'href': '../image/zziv9942188a.eps',
                                      'width': '9.000mm',
                                      'height': '5.000mm',
                                      'xoffset': '0.000mm',
                                      'yoffset': '0.000mm',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'list1': {
                                  'type': 'bull',
                                  'column': 'col',
                                  'children': [{
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '语言',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可更改多信息显示屏上的语言。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '单位',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可更改油耗的测量单位。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '仪表类型',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可更改仪表显示类型。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'children': [{
                                            'symbol': {
                                              'href': '../image/zziv9942190a.eps',
                                              'width': '9.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'xref': {
                                              'type': 'P.page',
                                              'srcfile': 'M0R089tocnzhvhch01.xml#ch01se040401050206060702',
                                              'ref_em': 'yes',
                                              'ref_pm': 'yes',
                                              'ref_fullpm': 'yes',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可启用/禁用 EV 指示灯。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'children': [{
                                            'symbol': {
                                              'href': '../image/zziv9942172a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可设定以下项目。',
                                          'children': []
                                        }
                                      }, {
                                        'list2': {
                                          'type': 'dot',
                                          'children': [{
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '“',
                                                  'children': [{
                                                    'function': {
                                                      'text': '混合动力系统',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'itemtxt_sub': {
                                                  'page': 'none',
                                                  'text': '选择可启用/禁用 ECO 加速器指南（[rarr]',
                                                  'children': [{
                                                    'xref': {
                                                      'refid': 'ch02se01040305050603',
                                                      'type': 'P.page',
                                                      'ref_em': 'yes',
                                                      'ref_pm': 'yes',
                                                      'ref_fullpm': 'yes',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '“',
                                                  'children': [{
                                                    'function': {
                                                      'text': '驾驶信息类型',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'itemtxt_sub': {
                                                  'page': 'none',
                                                  'text': '选择可在行程和总计之间切换驾驶信息类型显示（[rarr]',
                                                  'children': [{
                                                    'xref': {
                                                      'refid': 'ch02se01040305050602',
                                                      'type': 'P.page',
                                                      'ref_em': 'yes',
                                                      'ref_pm': 'yes',
                                                      'ref_fullpm': 'yes',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '“',
                                                  'children': [{
                                                    'function': {
                                                      'text': '驾驶信息项目',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'itemtxt_sub': {
                                                  'page': 'none',
                                                  'text': '选择可设定驾驶信息画面的项目，选项包括平均车速、里程和总时间（[rarr]',
                                                  'children': [{
                                                    'xref': {
                                                      'refid': 'ch02se01040305050602',
                                                      'type': 'P.page',
                                                      'ref_em': 'yes',
                                                      'ref_pm': 'yes',
                                                      'ref_fullpm': 'yes',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'children': [{
                                            'symbol': {
                                              'href': '../image/zziv9942174a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可启用/禁用',
                                          'children': [{
                                            'symbol': {
                                              'href': '../image/zziv9942174a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'children': [{
                                            'symbol': {
                                              'href': '../image/zziv9942175a.eps',
                                              'width': '7.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'list2': {
                                          'type': 'dot',
                                          'children': [{
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '“',
                                                  'children': [{
                                                    'function': {
                                                      'text': '显示内容',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'itemtxt_sub': {
                                                  'page': 'none',
                                                  'text': '选择可设定以下项目。',
                                                  'children': []
                                                }
                                              }, {
                                                'itemtxt_sub': {
                                                  'page': 'none',
                                                  'text': '“',
                                                  'children': [{
                                                    'function': {
                                                      'text': '能量监视器',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'itemtxt_sub': {
                                                  'page': 'none',
                                                  'text': '选择可启用/禁用能量监控屏（[rarr]',
                                                  'children': [{
                                                    'xref': {
                                                      'refid': 'ch02se010405',
                                                      'type': 'P.page',
                                                      'ref_em': 'yes',
                                                      'ref_pm': 'yes',
                                                      'ref_fullpm': 'yes',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'itemtxt_sub': {
                                                  'page': 'none',
                                                  'text': 'AWD（AWD 车型）：',
                                                  'children': []
                                                }
                                              }, {
                                                'itemtxt_sub': {
                                                  'page': 'none',
                                                  'text': '选择可启用/禁用 AWD 系统显示（[rarr]',
                                                  'children': [{
                                                    'xref': {
                                                      'refid': 'ch02se01040305080603',
                                                      'type': 'P.page',
                                                      'ref_em': 'yes',
                                                      'ref_pm': 'yes',
                                                      'ref_fullpm': 'yes',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '最终画面',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可设定电源开关关闭时显示的项目。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '弹出式显示',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可启用/禁用下列弹出式显示，这些显示会在某些情况下出现。',
                                          'children': []
                                        }
                                      }, {
                                        'list2': {
                                          'type': 'dot',
                                          'children': [{
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '导航系统相关系统的交叉路口引导显示',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '免提电话系统的来电显示',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '音响操作',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '音量操作',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '语音控制（如有配备）',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '亮度',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '关闭MID',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '显示空白画面。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '“',
                                          'children': [{
                                            'function': {
                                              'text': '默认设定',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可复位仪表显示设定。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'note': {
                              'id': 'ch02se01040305090613',
                              'column': 'col',
                              'page': 'none',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'note_body': {
                                  'children': [{
                                    'note_para': {
                                      'id': 'ch02se010403050906130701',
                                      'publish_em': 'yes',
                                      'publish_pm': 'yes',
                                      'publish_fullpm': 'yes',
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '暂停设定显示',
                                          'children': []
                                        }
                                      }, {
                                        'att_list1': {
                                          'type': 'bull',
                                          'column': 'col',
                                          'children': [{
                                            'att_list1_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '在下列情况下，设定显示的操作将暂停。',
                                                  'children': []
                                                }
                                              }, {
                                                'att_list2': {
                                                  'type': 'dot',
                                                  'children': [{
                                                    'att_list2_item': {
                                                      'children': [{
                                                        'itemtxt': {
                                                          'page': 'none',
                                                          'text': '多信息显示屏上显示警告信息时',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }, {
                                                    'att_list2_item': {
                                                      'children': [{
                                                        'itemtxt': {
                                                          'page': 'none',
                                                          'text': '车辆开始移动时',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'att_list1_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '不显示车辆未配备的功能设定。',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'att_list1_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '关闭某功能时，该功能的相关设定不可选择。',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'attention': {
                              'id': 'ch02se01040305090614',
                              'type': 'warning',
                              'column': 'col',
                              'page': 'none',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'attentiontbl': {
                                  'tabletype': 'WarningTable',
                                  'width': '2.224in',
                                  'children': [{
                                    'attentiontbl_body': {
                                      'children': [{
                                        'attentiontbl_body_row': {
                                          'children': [{
                                            'attention_body': {
                                              'children': [{
                                                'attention_mark': {
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }, {
                                        'attentiontbl_body_row': {
                                          'children': [{
                                            'attention_body': {
                                              'children': [{
                                                'attention_para': {
                                                  'id': 'ch02se010403050906140701',
                                                  'publish_em': 'yes',
                                                  'publish_pm': 'yes',
                                                  'publish_fullpm': 'yes',
                                                  'children': [{
                                                    'title': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '设定显示时的注意事项',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '设定显示过程中需要保持混合动力系统运行，因此确保将车辆停放在通风良好的地点。在密闭的场所（如车库），含有有害气体一氧化碳（CO）的废气可能聚集并进入车内。这可能严重危害身体健康甚至导致死亡。',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'attention': {
                              'id': 'ch02se01040305090615',
                              'type': 'notice',
                              'column': 'col',
                              'page': 'none',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'attentiontbl': {
                                  'tabletype': 'CautionTable',
                                  'width': '2.224in',
                                  'children': [{
                                    'attentiontbl_body': {
                                      'children': [{
                                        'attentiontbl_body_row': {
                                          'children': [{
                                            'attention_body': {
                                              'children': [{
                                                'attention_mark': {
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }, {
                                        'attentiontbl_body_row': {
                                          'children': [{
                                            'attention_body': {
                                              'children': [{
                                                'attention_para': {
                                                  'id': 'ch02se010403050906150701',
                                                  'publish_em': 'yes',
                                                  'publish_pm': 'yes',
                                                  'publish_fullpm': 'yes',
                                                  'children': [{
                                                    'title': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '设定显示时',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '为防止 12 伏蓄电池电量耗尽，设定显示功能时确保混合动力系统运行。',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }, {
                    'subsection_attention': {
                      'id': 'ch02se010404',
                      'column': 'col',
                      'publish_em': 'yes',
                      'publish_pm': 'yes',
                      'publish_fullpm': 'yes',
                      'children': [{
                        'titlegroup': {
                          'tabletype': 'SubSection_title',
                          'width': '2.224in',
                          'children': [{
                            'titlegroupbody': {
                              'children': [{
                                'titlegrouprow': {
                                  'children': [{
                                    'titlegroupcell': {
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'children': [{
                                            'indexmarker': {
                                              'marker': '平视显示器',
                                              'children': []
                                            }
                                          }, {
                                            'sup': {
                                              'text': '*',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }, {
                        'overview': {
                          'id': 'ch02se0104040501',
                          'publish_em': 'yes',
                          'publish_pm': 'yes',
                          'publish_fullpm': 'yes',
                          'children': [{
                            'footnote': {
                              'type': 'other',
                              'children': [{
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '如有配备',
                                  'children': []
                                }
                              }]
                            }
                          }, {
                            'para': {
                              'column': 'col',
                              'page': 'none',
                              'children': [{
                                'paratable': {
                                  'tabletype': 'ParaTable',
                                  'width': '2.205in',
                                  'children': [{
                                    'paratablebody': {
                                      'children': [{
                                        'paratablerow': {
                                          'children': [{
                                            'paratablecell': {
                                              'children': [{
                                                'paratabletxt': {
                                                  'type': 'typeA',
                                                  'text': '平视显示器在风挡玻璃上投影各种与驾驶相关的信息及驾驶辅助系统的操作状态。',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }, {
                        'topic': {
                          'id': 'ch02se0104040502',
                          'column': 'col',
                          'page': 'none',
                          'publish_em': 'yes',
                          'publish_pm': 'yes',
                          'publish_fullpm': 'yes',
                          'children': [{
                            'titlegroup': {
                              'tabletype': 'Topic_title',
                              'width': '2.185in',
                              'children': [{
                                'titlegroupbody': {
                                  'children': [{
                                    'titlegrouprow': {
                                      'children': [{
                                        'titlegroupcell': {
                                          'children': [{
                                            'title': {
                                              'column': 'full',
                                              'page': 'none',
                                              'text': '系统部件',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'om_body': {
                              'id': 'ch02se01040405020601',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'fig': {
                                  'column': 'col',
                                  'page': 'none',
                                  'publish_em': 'yes',
                                  'publish_pm': 'yes',
                                  'publish_fullpm': 'yes',
                                  'children': [{
                                    'image': {
                                      'href': '../image/zziv0243046a.eps',
                                      'width': '56mm',
                                      'height': '57mm',
                                      'border': '1',
                                      'xoffset': '0.000mm',
                                      'yoffset': '0.000mm',
                                      'children': []
                                    }
                                  }, {
                                    'p': {
                                      'column': 'col',
                                      'page': 'none',
                                      'text': '本手册中使用的插图仅作为示例，可能与平视显示器上显示的实际图像不同。',
                                      'children': []
                                    }
                                  }, {
                                    'callout': {
                                      'type': 'illust',
                                      'startnumber': '1',
                                      'children': [{
                                        'calloutitem': {
                                          'children': [{
                                            'callouttxt': {
                                              'column': 'col',
                                              'page': 'none',
                                              'children': [{
                                                'symbol': {
                                                  'href': '../common/step_a.eps',
                                                  'width': '5.000mm',
                                                  'height': '5.000mm',
                                                  'xoffset': '0.000mm',
                                                  'yoffset': '0.355mm',
                                                  'children': []
                                                }
                                              }, {
                                                'break': {
                                                  'type': 'tab',
                                                  'text': '驾驶辅助系统信息/导航系统相关显示区域（[rarr]',
                                                  'children': []
                                                }
                                              }, {
                                                'xref': {
                                                  'refid': 'ch02se0104040504',
                                                  'type': 'P.page',
                                                  'ref_em': 'yes',
                                                  'ref_pm': 'yes',
                                                  'ref_fullpm': 'yes',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }, {
                                        'calloutitem': {
                                          'children': [{
                                            'callouttxt': {
                                              'column': 'col',
                                              'page': 'none',
                                              'children': [{
                                                'symbol': {
                                                  'href': '../common/step_b.eps',
                                                  'width': '5.000mm',
                                                  'height': '5.000mm',
                                                  'xoffset': '0.000mm',
                                                  'yoffset': '0.355mm',
                                                  'children': []
                                                }
                                              }, {
                                                'break': {
                                                  'type': 'tab',
                                                  'text': '档位显示区域（[rarr]',
                                                  'children': []
                                                }
                                              }, {
                                                'xref': {
                                                  'type': 'P.page',
                                                  'srcfile': 'M0R089tocnzhvhch04.xml#ch04se020403',
                                                  'ref_em': 'yes',
                                                  'ref_pm': 'yes',
                                                  'ref_fullpm': 'yes',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }, {
                                        'calloutitem': {
                                          'children': [{
                                            'callouttxt': {
                                              'column': 'col',
                                              'page': 'none',
                                              'children': [{
                                                'symbol': {
                                                  'href': '../common/step_c.eps',
                                                  'width': '5.000mm',
                                                  'height': '5.000mm',
                                                  'xoffset': '0.000mm',
                                                  'yoffset': '0.355mm',
                                                  'children': []
                                                }
                                              }, {
                                                'break': {
                                                  'type': 'tab',
                                                  'text': '车速显示',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }, {
                                        'calloutitem': {
                                          'children': [{
                                            'callouttxt': {
                                              'column': 'col',
                                              'page': 'none',
                                              'children': [{
                                                'symbol': {
                                                  'href': '../common/step_d.eps',
                                                  'width': '5.000mm',
                                                  'height': '5.000mm',
                                                  'xoffset': '0.000mm',
                                                  'yoffset': '0.355mm',
                                                  'children': []
                                                }
                                              }, {
                                                'break': {
                                                  'type': 'tab',
                                                  'text': '混合动力系统指示仪/转速表（[rarr]',
                                                  'children': []
                                                }
                                              }, {
                                                'xref': {
                                                  'refid': 'ch02se0104040506',
                                                  'type': 'P.page',
                                                  'ref_em': 'yes',
                                                  'ref_pm': 'yes',
                                                  'ref_fullpm': 'yes',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }, {
                                'note': {
                                  'id': 'ch02se010404050206010701',
                                  'column': 'col',
                                  'page': 'none',
                                  'publish_em': 'yes',
                                  'publish_pm': 'yes',
                                  'publish_fullpm': 'yes',
                                  'children': [{
                                    'note_body': {
                                      'children': [{
                                        'note_para': {
                                          'id': 'ch02se0104040502060107010801',
                                          'publish_em': 'yes',
                                          'publish_pm': 'yes',
                                          'publish_fullpm': 'yes',
                                          'children': [{
                                            'title': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '平视显示器的操作条件',
                                              'children': []
                                            }
                                          }, {
                                            'p': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '电源开关置于 ON。',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }, {
                                'attention': {
                                  'id': 'ch02se010404050206010702',
                                  'type': 'warning',
                                  'column': 'col',
                                  'page': 'none',
                                  'publish_em': 'yes',
                                  'publish_pm': 'yes',
                                  'publish_fullpm': 'yes',
                                  'children': [{
                                    'attentiontbl': {
                                      'tabletype': 'WarningTable',
                                      'width': '2.224in',
                                      'children': [{
                                        'attentiontbl_body': {
                                          'children': [{
                                            'attentiontbl_body_row': {
                                              'children': [{
                                                'attention_body': {
                                                  'children': [{
                                                    'attention_mark': {
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'attentiontbl_body_row': {
                                              'children': [{
                                                'attention_body': {
                                                  'children': [{
                                                    'attention_para': {
                                                      'id': 'ch02se0104040502060107020801',
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'title': {
                                                          'column': 'col',
                                                          'page': 'none',
                                                          'text': '使用平视显示器时',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'att_list1': {
                                                          'type': 'bull',
                                                          'column': 'col',
                                                          'children': [{
                                                            'att_list1_item': {
                                                              'children': [{
                                                                'itemtxt': {
                                                                  'page': 'none',
                                                                  'text': '检查并确认平视显示器显示画面的位置和亮度不会妨碍安全驾驶。画面位置或亮度调节不当可能妨碍驾驶员的视线并造成事故，从而导致严重伤亡。',
                                                                  'children': []
                                                                }
                                                              }]
                                                            }
                                                          }]
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'attentiontbl_body_row': {
                                              'children': [{
                                                'attention_body': {
                                                  'children': [{
                                                    'attention_para': {
                                                      'id': 'ch02se0104040502060107020802',
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'att_list1': {
                                                          'type': 'bull',
                                                          'column': 'col',
                                                          'children': [{
                                                            'att_list1_item': {
                                                              'children': [{
                                                                'itemtxt': {
                                                                  'page': 'none',
                                                                  'text': '驾驶过程中不要持续查看平视显示器，否则可能看不到车辆前方道路上的行人、物体等。',
                                                                  'children': []
                                                                }
                                                              }]
                                                            }
                                                          }]
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }, {
                                'attention': {
                                  'id': 'ch02se010404050206010703',
                                  'type': 'notice',
                                  'column': 'col',
                                  'page': 'none',
                                  'publish_em': 'yes',
                                  'publish_pm': 'yes',
                                  'publish_fullpm': 'yes',
                                  'children': [{
                                    'attentiontbl': {
                                      'tabletype': 'CautionTable',
                                      'width': '2.224in',
                                      'children': [{
                                        'attentiontbl_body': {
                                          'children': [{
                                            'attentiontbl_body_row': {
                                              'children': [{
                                                'attention_body': {
                                                  'children': [{
                                                    'attention_mark': {
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'attentiontbl_body_row': {
                                              'children': [{
                                                'attention_body': {
                                                  'children': [{
                                                    'attention_para': {
                                                      'id': 'ch02se0104040502060107030801',
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'title': {
                                                          'column': 'col',
                                                          'page': 'none',
                                                          'text': '平视显示器投影仪',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'att_list1': {
                                                          'type': 'bull',
                                                          'column': 'col',
                                                          'children': [{
                                                            'att_list1_item': {
                                                              'children': [{
                                                                'itemtxt': {
                                                                  'page': 'none',
                                                                  'text': '不要在平视显示器投影仪附近放置任何饮料。如果投影仪潮湿，可能造成电气故障。',
                                                                  'children': []
                                                                }
                                                              }, {
                                                                'att_fig': {
                                                                  'publish_em': 'yes',
                                                                  'publish_pm': 'yes',
                                                                  'publish_fullpm': 'yes',
                                                                  'children': [{
                                                                    'image': {
                                                                      'href': '../image/zziv0242302a.eps',
                                                                      'width': '45mm',
                                                                      'height': '30mm',
                                                                      'border': '1',
                                                                      'xoffset': '0.000mm',
                                                                      'yoffset': '0.000mm',
                                                                      'children': []
                                                                    }
                                                                  }]
                                                                }
                                                              }]
                                                            }
                                                          }]
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'attentiontbl_body_row': {
                                              'children': [{
                                                'attention_body': {
                                                  'children': [{
                                                    'attention_para': {
                                                      'id': 'ch02se0104040502060107030802',
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'att_list1': {
                                                          'type': 'bull',
                                                          'column': 'col',
                                                          'children': [{
                                                            'att_list1_item': {
                                                              'children': [{
                                                                'itemtxt': {
                                                                  'page': 'none',
                                                                  'text': '不要在平视显示器投影仪上放置任何物品或粘贴贴纸。',
                                                                  'children': [{
                                                                    'break': {
                                                                      'type': 'return',
                                                                      'children': []
                                                                    }
                                                                  }]
                                                                }
                                                              }]
                                                            }
                                                          }]
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'attentiontbl_body_row': {
                                              'children': [{
                                                'attention_body': {
                                                  'children': [{
                                                    'attention_para': {
                                                      'id': 'ch02se0104040502060107030803',
                                                      'publish_em': 'yes',
                                                      'publish_pm': 'yes',
                                                      'publish_fullpm': 'yes',
                                                      'children': [{
                                                        'att_list1': {
                                                          'type': 'bull',
                                                          'column': 'col',
                                                          'children': [{
                                                            'att_list1_item': {
                                                              'children': [{
                                                                'itemtxt': {
                                                                  'page': 'none',
                                                                  'text': '不要触摸平视显示器投影仪的内部或将任何尖锐物品插入投影仪。',
                                                                  'children': [{
                                                                    'break': {
                                                                      'type': 'return',
                                                                      'children': []
                                                                    }
                                                                  }]
                                                                }
                                                              }]
                                                            }
                                                          }]
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }, {
                        'topic': {
                          'id': 'ch02se0104040503',
                          'column': 'col',
                          'page': 'none',
                          'publish_em': 'yes',
                          'publish_pm': 'yes',
                          'publish_fullpm': 'yes',
                          'children': [{
                            'titlegroup': {
                              'tabletype': 'Topic_title',
                              'width': '2.185in',
                              'children': [{
                                'titlegroupbody': {
                                  'children': [{
                                    'titlegrouprow': {
                                      'children': [{
                                        'titlegroupcell': {
                                          'children': [{
                                            'title': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '使用平视显示器',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'om_body': {
                              'id': 'ch02se01040405030601',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '使用仪表控制开关可更改车辆设定和平视显示器上显示的内容。',
                                  'children': []
                                }
                              }, {
                                'step': {
                                  'column': 'col',
                                  'startnumber': '1',
                                  'children': [{
                                    'stepitem': {
                                      'column': 'col',
                                      'children': [{
                                        'steptxt': {
                                          'num': 'num',
                                          'page': 'none',
                                          'text': '操作仪表控制开关的',
                                          'children': [{
                                            'symbol': {
                                              'href': '../image/zziv9942021a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'symbol': {
                                              'href': '../image/zziv9942019a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'symbol': {
                                              'href': '../image/zziv9942176a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'stepitem': {
                                      'column': 'col',
                                      'children': [{
                                        'steptxt': {
                                          'num': 'num',
                                          'page': 'none',
                                          'text': '操作仪表控制开关的',
                                          'children': [{
                                            'symbol': {
                                              'href': '../image/zziv9942018a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'symbol': {
                                              'href': '../image/zziv9942020a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'function': {
                                              'text': 'HUD主',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'om_body': {
                              'id': 'ch02se01040405030602',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'title': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '启用/禁用平视显示器',
                                  'children': []
                                }
                              }, {
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '按下',
                                  'children': [{
                                    'symbol': {
                                      'href': '../image/zziv9942023a.eps',
                                      'width': '5.000mm',
                                      'height': '5.000mm',
                                      'xoffset': '0.000mm',
                                      'yoffset': '0.000mm',
                                      'children': []
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'om_body': {
                              'id': 'ch02se01040405030603',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'title': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '更改平视显示器设定',
                                  'children': []
                                }
                              }, {
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '按住',
                                  'children': [{
                                    'symbol': {
                                      'href': '../image/zziv9942023a.eps',
                                      'width': '5.000mm',
                                      'height': '5.000mm',
                                      'xoffset': '0.000mm',
                                      'yoffset': '0.000mm',
                                      'children': []
                                    }
                                  }]
                                }
                              }, {
                                'list1': {
                                  'type': 'bull',
                                  'column': 'col',
                                  'children': [{
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '平视显示器的亮度和垂直位置',
                                          'children': []
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可调节平视显示器的亮度或垂直位置。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '显示内容',
                                          'children': []
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可切换显示下列项目：',
                                          'children': []
                                        }
                                      }, {
                                        'list2': {
                                          'type': 'dot',
                                          'children': [{
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '无内容',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '混合动力系统指示仪',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '转速表',
                                                  'children': []
                                                }
                                              }, {
                                                'itemtxt_sub': {
                                                  'page': 'none',
                                                  'text': '选择可启用/禁用以下项目：',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '至目的地的路径引导',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '驾驶辅助系统信息显示',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '罗盘',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'list2_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '音响系统操作状态',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'list1_item': {
                                      'children': [{
                                        'itemtxt': {
                                          'page': 'none',
                                          'text': '显示器倾角',
                                          'children': []
                                        }
                                      }, {
                                        'itemtxt_sub': {
                                          'page': 'none',
                                          'text': '选择可调节平视显示器的倾角。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'note': {
                              'id': 'ch02se01040405030604',
                              'column': 'col',
                              'page': 'none',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'note_body': {
                                  'children': [{
                                    'note_para': {
                                      'id': 'ch02se010404050306040701',
                                      'publish_em': 'yes',
                                      'publish_pm': 'yes',
                                      'publish_fullpm': 'yes',
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '启用/禁用平视显示器',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '如果禁用了平视显示器，将电源开关关闭后再次置于 ON 时，仍保持禁用状态。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'note_para': {
                                      'id': 'ch02se010404050306040702',
                                      'publish_em': 'yes',
                                      'publish_pm': 'yes',
                                      'publish_fullpm': 'yes',
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '使用语音指令系统',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '可使用语音指令启用/禁用平视显示器。有关详情，请参见《',
                                          'children': [{
                                            'function': {
                                              'text': '导航系统用户手册',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'note_para': {
                                      'id': 'ch02se010404050306040703',
                                      'publish_em': 'yes',
                                      'publish_pm': 'yes',
                                      'publish_fullpm': 'yes',
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '显示器亮度',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '平视显示器的亮度可在多信息显示屏的',
                                          'children': [{
                                            'symbol': {
                                              'href': '../image/zziv9942176a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'attention': {
                              'id': 'ch02se01040405030605',
                              'type': 'warning',
                              'column': 'col',
                              'page': 'none',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'attentiontbl': {
                                  'tabletype': 'WarningTable',
                                  'width': '2.224in',
                                  'children': [{
                                    'attentiontbl_body': {
                                      'children': [{
                                        'attentiontbl_body_row': {
                                          'children': [{
                                            'attention_body': {
                                              'children': [{
                                                'attention_mark': {
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }, {
                                        'attentiontbl_body_row': {
                                          'children': [{
                                            'attention_body': {
                                              'children': [{
                                                'attention_para': {
                                                  'id': 'ch02se010404050306050701',
                                                  'publish_em': 'yes',
                                                  'publish_pm': 'yes',
                                                  'publish_fullpm': 'yes',
                                                  'children': [{
                                                    'title': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '更改平视显示器设定时的注意事项',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '如果更改显示设定时混合动力系统运行，确保将车辆停放在通风良好的地点。在密闭的场所（如车库），含有有害气体一氧化碳（CO）的废气可能聚集并进入车内。这可能严重危害身体健康甚至导致死亡。',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'attention': {
                              'id': 'ch02se01040405030606',
                              'type': 'notice',
                              'column': 'col',
                              'page': 'none',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'attentiontbl': {
                                  'tabletype': 'CautionTable',
                                  'width': '2.224in',
                                  'children': [{
                                    'attentiontbl_body': {
                                      'children': [{
                                        'attentiontbl_body_row': {
                                          'children': [{
                                            'attention_body': {
                                              'children': [{
                                                'attention_mark': {
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }, {
                                        'attentiontbl_body_row': {
                                          'children': [{
                                            'attention_body': {
                                              'children': [{
                                                'attention_para': {
                                                  'id': 'ch02se010404050306060701',
                                                  'publish_em': 'yes',
                                                  'publish_pm': 'yes',
                                                  'publish_fullpm': 'yes',
                                                  'children': [{
                                                    'title': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '更改平视显示器设定时',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'p': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'text': '为防止 12 伏蓄电池电量耗尽，更改平视显示器设定时确保混合动力系统运行。',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }, {
                    'subsection_operation': {
                      'id': 'ch02se010405',
                      'column': 'col',
                      'publish_em': 'yes',
                      'publish_pm': 'yes',
                      'publish_fullpm': 'yes',
                      'children': [{
                        'titlegroup': {
                          'tabletype': 'SubSection_title',
                          'width': '2.224in',
                          'children': [{
                            'titlegroupbody': {
                              'children': [{
                                'titlegrouprow': {
                                  'children': [{
                                    'titlegroupcell': {
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'children': [{
                                            'indexmarker': {
                                              'marker': '能量监控屏/油耗画面',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }, {
                        'topic_function_basic': {
                          'id': 'ch02se0104050503',
                          'column': 'col',
                          'page': 'none',
                          'publish_em': 'yes',
                          'publish_pm': 'yes',
                          'publish_fullpm': 'yes',
                          'children': [{
                            'titlegroup': {
                              'tabletype': 'Topic_title',
                              'width': '2.185in',
                              'children': [{
                                'titlegroupbody': {
                                  'children': [{
                                    'titlegrouprow': {
                                      'children': [{
                                        'titlegroupcell': {
                                          'children': [{
                                            'title': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '能量监控屏',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'body': {
                              'children': [{
                                'p': {
                                  'text': '具体内容请参考用户手册电子版。',
                                  'children': []
                                }
                              }]
                            }
                          }, {
                            'basic_operation': {
                              'id': 'ch02se01040505030602',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'title': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '显示步骤',
                                  'children': []
                                }
                              }, {
                                'paraselect': {
                                  'children': [{
                                    'paraselectitem': {
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '多信息显示屏',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '按下方向盘上的仪表控制开关的',
                                          'children': [{
                                            'symbol': {
                                              'href': '../image/zziv9942021a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'symbol': {
                                              'href': '../image/zziv9942019a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'symbol': {
                                              'href': '../image/zzcv02aq190a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'symbol': {
                                              'href': '../image/zziv9942018a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'symbol': {
                                              'href': '../image/zziv9942020a.eps',
                                              'width': '5.000mm',
                                              'height': '5.000mm',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'paraselectitem': {
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '多媒体显示屏',
                                          'children': []
                                        }
                                      }, {
                                        'step': {
                                          'column': 'col',
                                          'startnumber': '1',
                                          'children': [{
                                            'stepitem': {
                                              'column': 'col',
                                              'children': [{
                                                'steptxt': {
                                                  'num': 'num',
                                                  'page': 'none',
                                                  'text': '选择',
                                                  'children': [{
                                                    'symbol': {
                                                      'href': '../image/zziv9943059a.eps',
                                                      'width': '5.000mm',
                                                      'height': '5.000mm',
                                                      'xoffset': '0.000mm',
                                                      'yoffset': '0.000mm',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'steptxt_sub': {
                                                  'page': 'none',
                                                  'text': '使用“',
                                                  'children': [{
                                                    'function': {
                                                      'text': '导航首页',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'symbol': {
                                                      'href': '../image/zziv9942313b.eps',
                                                      'width': '5.000mm',
                                                      'height': '5.000mm',
                                                      'xoffset': '0.000mm',
                                                      'yoffset': '0.000mm',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'fig': {
                                                  'column': 'col',
                                                  'page': 'none',
                                                  'publish_em': 'yes',
                                                  'publish_pm': 'yes',
                                                  'publish_fullpm': 'yes',
                                                  'children': [{
                                                    'image': {
                                                      'href': '../image/zziv0842184d.eps',
                                                      'width': '56mm',
                                                      'height': '38mm',
                                                      'border': '1',
                                                      'xoffset': '0.000mm',
                                                      'yoffset': '0.000mm',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'stepitem': {
                                              'column': 'col',
                                              'children': [{
                                                'steptxt': {
                                                  'num': 'num',
                                                  'page': 'none',
                                                  'text': '选择“',
                                                  'children': [{
                                                    'function': {
                                                      'text': '能耗动力',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'function': {
                                                      'text': '能量流',
                                                      'children': []
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'basic_operation': {
                              'id': 'ch02se01040505030603',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'title': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '读取显示内容',
                                  'children': []
                                }
                              }, {
                                'p': {
                                  'column': 'col',
                                  'page': 'none',
                                  'text': '将根据能量流显示箭头。无能量流动时，将不显示箭头。',
                                  'children': []
                                }
                              }, {
                                'paraselect': {
                                  'children': [{
                                    'paraselectitem': {
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '多信息显示屏',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '箭头的颜色如下变化：',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '绿色：混合动力蓄电池（牵引用蓄电池）再生或充电时。',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '黄色：使用混合动力蓄电池（牵引用蓄电池）时。',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '红色：使用汽油发动机时。',
                                          'children': []
                                        }
                                      }, {
                                        'fig': {
                                          'column': 'col',
                                          'page': 'none',
                                          'publish_em': 'yes',
                                          'publish_pm': 'yes',
                                          'publish_fullpm': 'yes',
                                          'children': [{
                                            'image': {
                                              'href': '../image/zzcv02aq285a.eps',
                                              'width': '56mm',
                                              'height': '38mm',
                                              'border': '1',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'p': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '图像显示所有箭头作为示例。实际显示将随具体条件而变化。',
                                              'children': []
                                            }
                                          }, {
                                            'callout': {
                                              'type': 'illust',
                                              'startnumber': '1',
                                              'children': [{
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_a.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '汽油发动机',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_b.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '混合动力蓄电池（牵引用蓄电池）',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_c.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '前轮胎',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_d.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '后轮胎',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'sup': {
                                                          'text': '*',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }, {
                                        'footnote': {
                                          'type': 'other',
                                          'children': [{
                                            'p': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '对于 FF 车辆，不显示指向',
                                              'children': [{
                                                'symbol': {
                                                  'href': '../common/step_d.eps',
                                                  'width': '5.000mm',
                                                  'height': '5.000mm',
                                                  'xoffset': '0.000mm',
                                                  'yoffset': '0.355mm',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'paraselectitem': {
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '多媒体显示屏',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '箭头的颜色如下变化：',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '绿色：混合动力蓄电池（牵引用蓄电池）再生或充电时。',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '黄色：使用电能时，或使用汽油发动机充电时。',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '红色：使用汽油发动机驾驶车辆时。',
                                          'children': []
                                        }
                                      }, {
                                        'fig': {
                                          'column': 'col',
                                          'page': 'none',
                                          'publish_em': 'yes',
                                          'publish_pm': 'yes',
                                          'publish_fullpm': 'yes',
                                          'children': [{
                                            'image': {
                                              'href': '../image/zziv0248180a.eps',
                                              'width': '56mm',
                                              'height': '38mm',
                                              'border': '1',
                                              'xoffset': '0.000mm',
                                              'yoffset': '0.000mm',
                                              'children': []
                                            }
                                          }, {
                                            'p': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '图像显示所有箭头作为示例。实际显示将随具体条件而变化。',
                                              'children': []
                                            }
                                          }, {
                                            'callout': {
                                              'type': 'illust',
                                              'startnumber': '1',
                                              'children': [{
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_a.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '汽油发动机',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_b.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '前电动马达（牵引马达）',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_c.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '混合动力蓄电池（牵引用蓄电池）',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_d.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '后电动马达（牵引马达）',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'sup': {
                                                          'text': '*1',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_e.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '前轮胎',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }, {
                                                'calloutitem': {
                                                  'children': [{
                                                    'callouttxt': {
                                                      'column': 'col',
                                                      'page': 'none',
                                                      'children': [{
                                                        'symbol': {
                                                          'href': '../common/step_f.eps',
                                                          'width': '5.000mm',
                                                          'height': '5.000mm',
                                                          'xoffset': '0.000mm',
                                                          'yoffset': '0.355mm',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'break': {
                                                          'type': 'tab',
                                                          'text': '后轮胎',
                                                          'children': []
                                                        }
                                                      }, {
                                                        'sup': {
                                                          'text': '*2',
                                                          'children': []
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }, {
                                        'footnote': {
                                          'type': 'other',
                                          'num': '1',
                                          'children': [{
                                            'p': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '仅 AWD 车型',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }, {
                                        'footnote': {
                                          'type': 'other',
                                          'num': '2',
                                          'children': [{
                                            'p': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '对于 FF 车辆，不显示指向',
                                              'children': [{
                                                'symbol': {
                                                  'href': '../common/step_f.eps',
                                                  'width': '5.000mm',
                                                  'height': '5.000mm',
                                                  'xoffset': '0.000mm',
                                                  'yoffset': '0.355mm',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'note': {
                              'id': 'ch02se01040505030604',
                              'column': 'col',
                              'page': 'none',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'note_body': {
                                  'children': [{
                                    'note_para': {
                                      'id': 'ch02se010405050306040701',
                                      'publish_em': 'yes',
                                      'publish_pm': 'yes',
                                      'publish_fullpm': 'yes',
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '混合动力蓄电池（牵引用蓄电池）的状态',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '图像仅作为示例，可能与实际情况略有差异。',
                                          'children': []
                                        }
                                      }, {
                                        'att_list1': {
                                          'type': 'dash',
                                          'column': 'col',
                                          'children': [{
                                            'att_list1_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '多信息显示屏',
                                                  'children': []
                                                }
                                              }, {
                                                'att_fig': {
                                                  'publish_em': 'yes',
                                                  'publish_pm': 'yes',
                                                  'publish_fullpm': 'yes',
                                                  'children': [{
                                                    'image': {
                                                      'href': '../image/zziv0248177b.eps',
                                                      'width': '45mm',
                                                      'height': '30mm',
                                                      'border': '1',
                                                      'xoffset': '0.000mm',
                                                      'yoffset': '0.000mm',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'att_callout': {
                                                      'type': 'illust',
                                                      'startnumber': '1',
                                                      'children': [{
                                                        'calloutitem': {
                                                          'children': [{
                                                            'callouttxt': {
                                                              'column': 'col',
                                                              'page': 'none',
                                                              'children': [{
                                                                'symbol': {
                                                                  'href': '../common/step_a.eps',
                                                                  'width': '5.000mm',
                                                                  'height': '5.000mm',
                                                                  'xoffset': '0.000mm',
                                                                  'yoffset': '0.355mm',
                                                                  'children': []
                                                                }
                                                              }, {
                                                                'break': {
                                                                  'type': 'tab',
                                                                  'text': '低',
                                                                  'children': []
                                                                }
                                                              }]
                                                            }
                                                          }]
                                                        }
                                                      }, {
                                                        'calloutitem': {
                                                          'children': [{
                                                            'callouttxt': {
                                                              'column': 'col',
                                                              'page': 'none',
                                                              'children': [{
                                                                'symbol': {
                                                                  'href': '../common/step_b.eps',
                                                                  'width': '5.000mm',
                                                                  'height': '5.000mm',
                                                                  'xoffset': '0.000mm',
                                                                  'yoffset': '0.355mm',
                                                                  'children': []
                                                                }
                                                              }, {
                                                                'break': {
                                                                  'type': 'tab',
                                                                  'text': '高',
                                                                  'children': []
                                                                }
                                                              }]
                                                            }
                                                          }]
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }, {
                                            'att_list1_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '多媒体显示屏',
                                                  'children': []
                                                }
                                              }, {
                                                'att_fig': {
                                                  'publish_em': 'yes',
                                                  'publish_pm': 'yes',
                                                  'publish_fullpm': 'yes',
                                                  'children': [{
                                                    'image': {
                                                      'href': '../image/zziv0248181a.eps',
                                                      'width': '56mm',
                                                      'height': '38mm',
                                                      'border': '1',
                                                      'xoffset': '0.000mm',
                                                      'yoffset': '0.000mm',
                                                      'children': []
                                                    }
                                                  }, {
                                                    'att_callout': {
                                                      'type': 'illust',
                                                      'startnumber': '1',
                                                      'children': [{
                                                        'calloutitem': {
                                                          'children': [{
                                                            'callouttxt': {
                                                              'column': 'col',
                                                              'page': 'none',
                                                              'children': [{
                                                                'symbol': {
                                                                  'href': '../common/step_a.eps',
                                                                  'width': '5.000mm',
                                                                  'height': '5.000mm',
                                                                  'xoffset': '0.000mm',
                                                                  'yoffset': '0.355mm',
                                                                  'children': []
                                                                }
                                                              }, {
                                                                'break': {
                                                                  'type': 'tab',
                                                                  'text': '放电中（黄色）',
                                                                  'children': []
                                                                }
                                                              }]
                                                            }
                                                          }]
                                                        }
                                                      }, {
                                                        'calloutitem': {
                                                          'children': [{
                                                            'callouttxt': {
                                                              'column': 'col',
                                                              'page': 'none',
                                                              'children': [{
                                                                'symbol': {
                                                                  'href': '../common/step_b.eps',
                                                                  'width': '5.000mm',
                                                                  'height': '5.000mm',
                                                                  'xoffset': '0.000mm',
                                                                  'yoffset': '0.355mm',
                                                                  'children': []
                                                                }
                                                              }, {
                                                                'break': {
                                                                  'type': 'tab',
                                                                  'text': '充电中（绿色）',
                                                                  'children': []
                                                                }
                                                              }]
                                                            }
                                                          }]
                                                        }
                                                      }]
                                                    }
                                                  }]
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }, {
                                    'note_para': {
                                      'id': 'ch02se010405050306040702',
                                      'publish_em': 'yes',
                                      'publish_pm': 'yes',
                                      'publish_fullpm': 'yes',
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '多媒体显示屏上的电动马达（牵引马达）的颜色',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '绿色：混合动力蓄电池（牵引用蓄电池）由车辆动能转换的电能充电时。',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '黄色：使用混合动力蓄电池（牵引用蓄电池）时。',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '红色：混合动力蓄电池（牵引用蓄电池）由汽油发动机充电时。',
                                          'children': []
                                        }
                                      }]
                                    }
                                  }, {
                                    'note_para': {
                                      'id': 'ch02se010405050306040703',
                                      'publish_em': 'yes',
                                      'publish_pm': 'yes',
                                      'publish_fullpm': 'yes',
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '混合动力蓄电池（牵引用蓄电池）的剩余电量警告',
                                          'children': []
                                        }
                                      }, {
                                        'att_list1': {
                                          'type': 'bull',
                                          'column': 'col',
                                          'children': [{
                                            'att_list1_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '换档杆置于 N 位置时混合动力蓄电池（牵引用蓄电池）一直不充电，或剩余电量降到一定量以下时，蜂鸣器间歇式鸣响。如果剩余电量继续下降，蜂鸣器连续鸣响。',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }, {
                                            'att_list1_item': {
                                              'children': [{
                                                'itemtxt': {
                                                  'page': 'none',
                                                  'text': '多信息显示屏上显示警告信息且蜂鸣器鸣响时，请按照画面上显示的说明进行故障排除。',
                                                  'children': []
                                                }
                                              }]
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }, {
                        'topic_function_advanced': {
                          'id': 'ch02se0104050504',
                          'column': 'col',
                          'page': 'none',
                          'publish_em': 'yes',
                          'publish_pm': 'yes',
                          'publish_fullpm': 'yes',
                          'children': [{
                            'titlegroup': {
                              'tabletype': 'Topic_title',
                              'width': '2.185in',
                              'children': [{
                                'titlegroupbody': {
                                  'children': [{
                                    'titlegrouprow': {
                                      'children': [{
                                        'titlegroupcell': {
                                          'children': [{
                                            'title': {
                                              'column': 'col',
                                              'page': 'none',
                                              'text': '油耗',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }, {
                            'body': {
                              'children': [{
                                'p': {
                                  'text': '具体内容请参考用户手册电子版。',
                                  'children': []
                                }
                              }]
                            }
                          }, {
                            'note': {
                              'id': 'ch02se01040505040603',
                              'column': 'col',
                              'page': 'none',
                              'publish_em': 'yes',
                              'publish_pm': 'yes',
                              'publish_fullpm': 'yes',
                              'children': [{
                                'note_body': {
                                  'children': [{
                                    'note_para': {
                                      'id': 'ch02se010405050406030703',
                                      'publish_em': 'yes',
                                      'publish_pm': 'yes',
                                      'publish_fullpm': 'yes',
                                      'children': [{
                                        'title': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '续航里程',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '显示使用当前剩余燃油量预计可以行驶的最远里程。',
                                          'children': []
                                        }
                                      }, {
                                        'p': {
                                          'column': 'col',
                                          'page': 'none',
                                          'text': '该里程是根据平均油耗计算所得。',
                                          'children': [{
                                            'break': {
                                              'type': 'return',
                                              'children': []
                                            }
                                          }]
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        },
        widthpercent: 100,
        htmldata: '',
        serverpath: ''
      }
    },
    mounted: function () {
      that = this
      localStorage.setItem('widthpercent',this.widthpercent)
      if (localStorage.getItem('rulelist') !== null && localStorage.getItem('rulelist') !== undefined && localStorage.getItem('rulelist') !== '') {
        that.ruledata = JSON.parse(localStorage.getItem('rulelist'))
      } else {
        that.ruledata = []
      }
    },
    methods: {
      savebz () {
        this.activeName = 'htmledit'
        setTimeout(() => {
          const contentDiv = document.getElementById('finoutContent');
          if (contentDiv) {
            const allElements = contentDiv.querySelectorAll('div,p');
            window.console.log(that.ruledata[0])
            for (let i = 0; i < allElements.length; i++) {
              for (let index in that.ruledata) {
                window.console.log(that.ruledata[index].pointtxt)
                if (allElements[i].innerText === that.ruledata[index].pointtxt) {
                  const parentNode = allElements[i].parentNode;
                  // 使用父节点的removeChild方法删除当前找到的这个元素节点
                  parentNode.removeChild(allElements[i]);
                }
              }
            }
          }
          that.htmldata = contentDiv.innerHTML
        }, 1000); // 延迟1秒恢复高度，可根据实际情况调整时间，确保PDF保存操作已完成
      },
      addbz () {
        const contentDiv = document.getElementById('htmlOutput');
        if (contentDiv) {
          const allElements = contentDiv.querySelectorAll('div,p');
          for (let i = 0; i < allElements.length; i++) {
            for (let index in that.ruledata) {
              window.console.log(that.ruledata[index].pointtxt)
              if (allElements[i].innerText.replace(/\s/g, '') === that.ruledata[index].pointtxt.replace(/\s/g, '')) {
                allElements[i].style.border = '1px solid red'
              }
            }
          }
        }
      },
      rulemana () {
        this.ruleshow = true
      },
      addrule () {
        var adata = {
          pointtxt: this.ruletxt,
          opway: this.opway
        }
        that.ruledata.push(adata)
        localStorage.setItem('rulelist',JSON.stringify(that.ruledata))
      },
      handleNodeClick (data,e) {
        window.console.log(data,e)
        window.console.log(data.title)
        const contentDiv = document.getElementById('htmlOutput');
        const mainDiv = document.getElementById('ch02');
        if (contentDiv) {
          const spans = contentDiv.querySelectorAll('.titlegrouptitle');
          window.console.log(spans)
          for (let i = 0; i < spans.length; i++) {
            if (spans[i].innerText === data.title) {
              // 找到匹配文字的span元素，获取其在页面中的位置（相对于文档顶部的偏移量）
              const offsetTop = spans[i].offsetTop;
              // 使用window.scrollTo来滚动页面到对应的位置，这里采用平滑滚动的方式（可选参数{behavior: "smooth"}），如果不需要平滑滚动可以直接使用window.scroll(0, offsetTop);
              mainDiv.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
              });
              return;
            }
          }
        }
      },
      handlePreview1 () {},
      handleRemove1 () {},
      beforeUpload(file) {
        const allowedExtensions = ['.xml'];
        const extension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
        if (!allowedExtensions.includes(extension)) {
          this.$message.error('只允许上传 XML 文件！');
          return false;
        }
        return true;
      },
      handleUploadSuccess(response, file, fileList) {
        this.$message.success('文件上传成功！');
      },
      handleUploadError(error, file, fileList) {
        this.$message.error('文件上传失败！',error,file,fileList);
      },
      coverepstoimg () {
        this.$prompt('请输入服务器转换路径', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          that.$http({
            url: 'https://ecommapi.sqnetsoft.cn/coverepstojpg',
            // url: 'http://localhost:5709/coverepstojpg',
            method: 'post',
            data: {
              filepath: value
              // filepath: 'C:\\Users\\Administrator\\Desktop\\硕祺\\RAV4 HEV CKD_OM_01999-0R089_01-2409-00\\01999-0R089_FM+XML+EPS\\common'
            },
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              window.console.log(res)
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消转换'
          });
        });
      },
      uploadWithAxios (file) {
        window.console.log(file)
        const formData = new FormData();
        formData.append('file', file.file);
        that.$http({
          // url: 'https://ecommapi.sqnetsoft.cn/uploadxml',
          url: 'https://ecommapi.sqnetsoft.cn/uploadxml',
          method: 'post',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.data.code === 0) {
              that.xmldata = that.convertJsonToTree(res.data.jsondata)
              // that.xmlData1 = res.data.xmldata
              that.parseXml(res.data.xmldata)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      toxslt (file) {
        const formData = new FormData();
        formData.append('file', file.file);
        formData.append('xslttmp',localStorage.getItem('modtmp').toString())
        that.$http({
          // url: 'https://ecommapi.sqnetsoft.cn/uploadxml',
          url: 'https://ecommapi.sqnetsoft.cn/uploadxmltoxslt',
          method: 'post',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(function (res) {
            var tmpdata = res.data
            window.console.log(res)
            if (tmpdata.code === 0) {
              // that.xmlData1 = res.data.xmldata
              that.xsltContent = tmpdata.htmldata
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      findNodeObjectByPath(data, path, index = 0) {
        const parts = path.match(new RegExp('[^\\[\\]]+|\\[\\d+\\]', 'g')); // 使用RegExp构造函数创建正则表达式，注意对中括号进行转义
        const key = parts[index];
        if (index === parts.length - 1) {
          if (Array.isArray(data)) {
            const arrayIndex = parseInt(key.match(/\d+/)[0]);
            return data[arrayIndex];
          } else {
            return data[key];
          }
        }
        if (Array.isArray(data)) {
          for (let i = 0; i < data.length; i++) {
            const result = this.findNodeObjectByPath(data[i], path, index);
            if (result) {
              return result;
            }
          }
        } else if (typeof data === 'object' && data!== null) {
          if (data.hasOwnProperty(key)) {
            return this.findNodeObjectByPath(data[key], path, index + 1);
          }
        }
        return null;
      },
      replacestr () {
        var tmpdata = JSON.stringify(that.jsonData1)
        // that.jsonData1 = JSON.parse(tmpdata)
        that.jsonData1 = JSON.parse(tmpdata.replaceAll(localStorage.getItem('oldstr'),this.edittextinfo))
        that.tqcode()
        that.showEditInfo = false
        window.console.log('执行完毕了')
      },
      tqcode () {
        const generatedHtml = jsonToHtml(JSON.parse(JSON.stringify(this.jsonData1)));
        const contentDiv = document.getElementById('htmlOutput');
        if (contentDiv) {
          contentDiv.innerHTML = generatedHtml;
          const edittext = document.querySelectorAll('.edittext');
          // 遍历NodeList中的每个元素
          edittext.forEach((button) => {
            button.onclick = function () {
              console.log(this.dataset)
              that.showEditInfo = true
              that.edittextinfo = this.dataset.text
              localStorage.setItem('oldstr', this.dataset.text)
              // window.console.log(that.findNodeObjectByPath(tmpdata,this.dataset.path,0))
            };
          });
          // 处理最后一页，如果最后一页高度不足设定高度，添加min-height样式使其达到设定高度

          const topicTitleDiv = document.querySelector('.om_body');
          if (topicTitleDiv) {
            const pageHeight = 1320;
            const allElements = topicTitleDiv.querySelectorAll('.part');
            const fragment = document.createDocumentFragment();
            let currentSplitDiv = document.createElement('div');
            currentSplitDiv.className ='split-content';
            fragment.appendChild(currentSplitDiv);

            let currentHeight = 0;
            allElements.forEach((element) => {
              const elementHeight = element.getBoundingClientRect().height;
              // 判断元素是否为空元素（比如只包含空格等空白内容的元素）
              const isEmptyElement = element.textContent.trim() === '';
              if (!isEmptyElement && currentHeight + elementHeight > pageHeight) {
                currentSplitDiv = document.createElement('div');
                currentSplitDiv.className ='split-content';
                fragment.appendChild(currentSplitDiv);
                currentHeight = 0;
              }
              if (!isEmptyElement) {
                currentSplitDiv.appendChild(element);
                currentHeight += elementHeight;
              }
            });

            // 处理最后一页高度情况，不再添加空白div填充，而是根据实际内容调整布局
            const splitContents = fragment.querySelectorAll('.split-content');
            const lastSplitDiv = splitContents[splitContents.length - 1];
            if (lastSplitDiv) {
              const allLastPageElements = lastSplitDiv.querySelectorAll('.part,img');
              let lastPageHeight = 0;
              allLastPageElements.forEach((element) => {
                const elementHeight = element.getBoundingClientRect().height;
                // 同样判断元素是否为空元素
                const isEmptyElement = element.textContent.trim() === '';
                if (!isEmptyElement) {
                  lastPageHeight += elementHeight;
                }
              });
              // 如果最后一页内容高度小于设定高度，不做额外填充，保持自然状态
              if (lastPageHeight < pageHeight) {
                // 这里可以根据实际需求，选择是否添加一些提示信息之类的内容在最后一页底部等操作，目前先保持原样
              }
            }

            topicTitleDiv.appendChild(fragment);
          } else {
            console.error('未找到类名为om_body的元素，请检查HTML结构。');
          }
        }
        const fincontentDiv = document.getElementById('finoutContent');
        fincontentDiv.innerHTML = contentDiv.innerHTML
        that.htmldata = fincontentDiv.innerHTML
        that.jsonData = cretenodetree(JSON.parse(JSON.stringify(this.jsonData1)))
        window.console.log('树状数据',that.jsonData)
      },
      myReplaceAll(str, searchValue, replaceValue) {
        while (str.includes(searchValue)) {
          str = str.replace(searchValue, replaceValue);
        }
        return str;
      },
      outhtml () {
        var adata = {
          chapterid: '2',
          chaptercontext: this.htmldata
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addchaptercontext',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '输出完毕!'
              })
            } else {
              that.$message({
                type: 'error',
                message: '输出失败!'
              })
            }
          })
          .catch(function (error) {
            that.$message({
              type: 'error',
              message: '输出失败!'
            })
            console.log('error' + error)
          })
      },
      outpdf () {
        const chapterElements = document.querySelectorAll('.chapter')
        for (let i = 0; i < chapterElements.length; i++) {
          chapterElements[i].style.height = '100%';
        }
        const headerElement = document.getElementById('page-header');
        const footerElement = document.getElementById('page-footer');
        const element = this.$refs.finoutContent;
        const opt = {
          margin: 25,
          filename: 'my-document.pdf',
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          pagebreak: {mode: 'avoid-all'},
          // 自定义页眉页脚相关配置，动态调整内容
          header: {
            height: 30, // 页眉高度，与CSS中设置的margin-top对应
            contents: async function (pageNumber, numPages) {
              // 这里假设可以根据内容获取当前章节标题，示例简单返回固定字符串，实际需替换逻辑
              return headerElement.outerHTML;
            }
          },
          footer: {
            height: 30, // 页脚高度，与CSS中设置的margin-bottom对应
            contents: async function (pageNumber, numPages) {
              return footerElement.outerHTML;
            }
          }
        };
        html2pdf().from(element).set(opt).save();
        setTimeout(() => {
          for (let i = 0; i < chapterElements.length; i++) {
            chapterElements[i].style.height = '660px';
          }
        }, 2000); // 延迟1秒恢复高度，可根据实际情况调整时间，确保PDF保存操作已完成
      },
      toxsltex (file) {
        const formData = new FormData();
        formData.append('file', file.file)
        const loading = this.$loading({
          lock: true,
          text: '处理中，请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/transxslt',
          // url: 'http://localhost:5709/transxslt',
          method: 'post',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(function (res) {
            var tmpdata = res.data
            window.console.log(res)
            loading.close()
            if (tmpdata.code === 0) {
              // that.xmlData1 = res.data.xmldata
              that.xsltContent = tmpdata.htmldata
              // window.console.log(JSON.parse(tmpdata.jsondata))
              that.jsonData = cretenodetree(JSON.parse(tmpdata.jsondata).toyota_om_vh_cn_zh.children[0].book)
              var tmpdata1 = JSON.parse(tmpdata.jsondata).toyota_om_vh_cn_zh.children[0].book
              that.jsonData1 = tmpdata1
              window.console.log(JSON.stringify(that.jsonData1))
              const generatedHtml = jsonToHtml(tmpdata1);
              const contentDiv = document.getElementById('htmlOutput');
              if (contentDiv) {
                contentDiv.innerHTML = generatedHtml;
                const edittext = document.querySelectorAll('.edittext');
                // 遍历NodeList中的每个元素
                edittext.forEach((button) => {
                  button.onclick = function () {
                    console.log(this.dataset)
                    that.showEditInfo = true
                    that.edittextinfo = this.dataset.text
                    localStorage.setItem('oldstr',this.dataset.text)
                    // window.console.log(that.findNodeObjectByPath(tmpdata,this.dataset.path,0))
                  };
                });
                // 处理最后一页，如果最后一页高度不足设定高度，添加min-height样式使其达到设定高度
                const topicTitleDiv = document.querySelector('.om_body');
                if (topicTitleDiv) {
                  const pageHeight = 1320;
                  const allElements = topicTitleDiv.querySelectorAll('.part');
                  const fragment = document.createDocumentFragment();
                  let currentSplitDiv = document.createElement('div');
                  currentSplitDiv.className ='split-content';
                  fragment.appendChild(currentSplitDiv);

                  let currentHeight = 0;
                  allElements.forEach((element) => {
                    const elementHeight = element.getBoundingClientRect().height;
                    // 判断元素是否为空元素（比如只包含空格等空白内容的元素）
                    const isEmptyElement = element.textContent.trim() === '';
                    if (!isEmptyElement && currentHeight + elementHeight > pageHeight) {
                      currentSplitDiv = document.createElement('div');
                      currentSplitDiv.className ='split-content';
                      fragment.appendChild(currentSplitDiv);
                      currentHeight = 0;
                    }
                    if (!isEmptyElement) {
                      currentSplitDiv.appendChild(element);
                      currentHeight += elementHeight;
                    }
                  });

                  // 处理最后一页高度情况，不再添加空白div填充，而是根据实际内容调整布局
                  const splitContents = fragment.querySelectorAll('.split-content');
                  const lastSplitDiv = splitContents[splitContents.length - 1];
                  if (lastSplitDiv) {
                    const allLastPageElements = lastSplitDiv.querySelectorAll('.part,img');
                    let lastPageHeight = 0;
                    allLastPageElements.forEach((element) => {
                      const elementHeight = element.getBoundingClientRect().height;
                      // 同样判断元素是否为空元素
                      const isEmptyElement = element.textContent.trim() === '';
                      if (!isEmptyElement) {
                        lastPageHeight += elementHeight;
                      }
                    });
                    // 如果最后一页内容高度小于设定高度，不做额外填充，保持自然状态
                    if (lastPageHeight < pageHeight) {
                      // 这里可以根据实际需求，选择是否添加一些提示信息之类的内容在最后一页底部等操作，目前先保持原样
                    }
                  }

                  topicTitleDiv.appendChild(fragment);
                } else {
                  console.error('未找到类名为om_body的元素，请检查HTML结构。');
                }
              }
              const fincontentDiv = document.getElementById('finoutContent');
              fincontentDiv.innerHTML = contentDiv.innerHTML
              that.htmldata = fincontentDiv.innerHTML
              that.jsonData = cretenodetree(JSON.parse(JSON.stringify(that.jsonData1)))
              window.console.log('树状数据',that.jsonData)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      upmodtmp (file) {
        const formData = new FormData();
        formData.append('file', file.file);
        that.$http({
          // url: 'https://ecommapi.sqnetsoft.cn/uploadxml',
          url: 'https://ecommapi.sqnetsoft.cn/uploadxslt',
          method: 'post',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.data.code === 0) {
              // that.xmlData1 = res.data.xmldata
              localStorage.setItem('modtmp',res.data.xmldata)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      parseXml(xmlString) {
        const parser = new DOMParser();
        const xml = parser.parseFromString(xmlString, 'text/xml');
        const serializer = new XMLSerializer();
        this.xmlContent = serializer.serializeToString(xml.documentElement);
        window.console.log(this.xmlContent)
      },
      convertJsonToTree(jsonObj) {
        if (!jsonObj || typeof jsonObj!== 'object') return [];
        const tree = [];
        for (let key in jsonObj) {
          const node = {
            label: key,
            children: []
          };
          const childData = jsonObj[key];
          if (typeof childData === 'object') {
            node.children = this.convertJsonToTree(childData);
          } else {
            node.value = childData;
          }
          tree.push(node);
        }
        return tree;
      },
      uploadrule () {},
      outrule () {},
      changetwomod () {
        const chapterElements = document.querySelectorAll('.split-content')
        for (let i = 0; i < chapterElements.length; i++) {
          chapterElements[i].style.columnCount = '2';
          chapterElements[i].style.columnGap = '20px';
          // 同时兼容不同浏览器引擎的私有前缀写法（虽然现代浏览器大多对标准写法支持良好，但为了更全面兼容仍可添加）
          chapterElements[i].style['-webkit-columnCount'] = '2';
          chapterElements[i].style['-webkit-columnGap'] = '20px';
          chapterElements[i].style['-moz-columnCount'] = '2';
          chapterElements[i].style['-moz-columnGap'] = '20px';
        }
        // this.tqcode()
      },
      changetreemod () {
        const chapterElements = document.querySelectorAll('.split-content')
        for (let i = 0; i < chapterElements.length; i++) {
          chapterElements[i].style.columnCount = '3';
          chapterElements[i].style.columnGap = '20px';
          // 同时兼容不同浏览器引擎的私有前缀写法（虽然现代浏览器大多对标准写法支持良好，但为了更全面兼容仍可添加）
          chapterElements[i].style['-webkit-columnCount'] = '3';
          chapterElements[i].style['-webkit-columnGap'] = '20px';
          chapterElements[i].style['-moz-columnCount'] = '3';
          chapterElements[i].style['-moz-columnGap'] = '20px';
        }
      }
    }
  }
  function cretenodetree (jsonData) {
    window.console.log(jsonData)
    var treedata = []
    // 创建章节标题
    var tmpchild = []
    for (const key in jsonData.children) {
      if (jsonData.children[key].chapter) {
        for (const key1 in jsonData.children[key].chapter.children) {
          if (jsonData.children[key].chapter.children[key1].title) {
            var chaptertitetmp10 = {
              title: jsonData.children[key].chapter.children[key1].title,
              children: []
            }
            tmpchild.push(chaptertitetmp10)
          }
          var chaptersetiontitetmp = []
          var tmpattention = []
          if (jsonData.children[key].chapter.children[key1].section) {
            for (const key2 in jsonData.children[key].chapter.children[key1].section.children) {
              if (jsonData.children[key].chapter.children[key1].section.children[key2].title) {
                var chaptersectiontite = {
                  title: jsonData.children[key].chapter.children[key1].section.children[key2].title.text,
                  children: []
                }
                chaptersetiontitetmp.push(chaptersectiontite)
              }
              if (jsonData.children[key].chapter.children[key1].section.children[key2].subsection_attention) {
                for (const key3 in jsonData.children[key].chapter.children[key1].section.children[key2].subsection_attention.children) {
                  if (jsonData.children[key].chapter.children[key1].section.children[key2].subsection_attention.children[key3].titlegroup) {
                    if (jsonData.children[key].chapter.children[key1].section.children[key2].subsection_attention.children[key3].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text && jsonData.children[key].chapter.children[key1].section.children[key2].subsection_attention.children[key3].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text !== '') {
                      var chaptersectiontite3 = {
                        title: jsonData.children[key].chapter.children[key1].section.children[key2].subsection_attention.children[key3].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text,
                        children: []
                      }
                      tmpattention.push(chaptersectiontite3)
                    }
                    if (jsonData.children[key].chapter.children[key1].section.children[key2].subsection_attention.children[key3].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.children[0].indexmarker.marker && jsonData.children[key].chapter.children[key1].section.children[key2].subsection_attention.children[key3].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.children[0].indexmarker.marker !== '') {
                      var chaptersectiontite1 = {
                        title: jsonData.children[key].chapter.children[key1].section.children[key2].subsection_attention.children[key3].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.children[0].indexmarker.marker,
                        children: []
                      }
                      tmpattention.push(chaptersectiontite1)
                    }
                  }
                }
              }
              if (jsonData.children[key].chapter.children[key1].section.children[key2].subsection_operation) {
                for (const key3 in jsonData.children[key].chapter.children[key1].section.children[key2].subsection_operation.children) {
                  if (jsonData.children[key].chapter.children[key1].section.children[key2].subsection_operation.children[key3].titlegroup) {
                    window.console.log('标注位置',jsonData.children[key].chapter.children[key1].section.children[key2].subsection_operation.children[key3].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text)
                    if (jsonData.children[key].chapter.children[key1].section.children[key2].subsection_operation.children[key3].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text) {
                      var chaptersectiontite2 = {
                        title: jsonData.children[key].chapter.children[key1].section.children[key2].subsection_operation.children[key3].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text,
                        children: []
                      }
                      tmpattention.push(chaptersectiontite2)
                    }
                    if (jsonData.children[key].chapter.children[key1].section.children[key2].subsection_operation.children[key3].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.children[0].indexmarker.marker) {
                      var chaptersectiontite4 = {
                        title: jsonData.children[key].chapter.children[key1].section.children[key2].subsection_operation.children[key3].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.children[0].indexmarker.marker,
                        children: []
                      }
                      tmpattention.push(chaptersectiontite4)
                    }
                  }
                }
              }
              window.console.log('tmpattention',tmpattention)
              chaptersetiontitetmp[key].children = tmpattention
            }
          }
          tmpchild[0].children = chaptersetiontitetmp
        }
      }
    }
    treedata = tmpchild
    return treedata
  }
  function jsonToHtml(jsonElement) {
    if (Array.isArray(jsonElement)) {
      let htmlString = '';
      jsonElement.forEach(element => {
        htmlString += jsonToHtml(element);
      });
      return htmlString;
    } else if (typeof jsonElement === 'object') {
      if (jsonElement.hasOwnProperty('chapter')){
        window.console.log(jsonElement)
        var chapter=`<div class="chapter om_body" id="${jsonElement.chapter.id}">`
        /** chapter 节点  ****/
        for (var e = 0; e < jsonElement.chapter.children.length; e++) {
          if (jsonElement.chapter.children[e].title) {}
          if (jsonElement.chapter.children[e].section) {
            var section= ''
            for (var s = 0; s < jsonElement.chapter.children[e].section.children.length; s++) {
              section =`<div class="section">`
              /**  section 节点  ****/
              window.console.log('section节点',jsonElement.chapter.children[e].section.children[s])
              if (jsonElement.chapter.children[e].section.children[s].title) {
                var sattentiontitle=`<div class="subsection_attention title part"> </div>`
                section = section + sattentiontitle
              }
              if (jsonElement.chapter.children[e].section.children[s].subsection_attention) {
                window.console.log('执行',s)
                var sattention=`<div class="subsection_attention">`
                for (var z = 0; z < jsonElement.chapter.children[e].section.children[s].subsection_attention.children.length; z++) {
                  /**  subsection_attention titlegroup 节点  ****/
                  // 标题部分
                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].titlegroup) {
                    var titlegroup = `<div class="${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].titlegroup.tabletype}">`
                    var titlegroupbody = `<div class="titlegroupbody" id = "titlegroupbody">`
                    var titlegrouprow = `<div class="titlegrouprow" id = "titlegrouprow">`
                    var titlegroupcell = `<div class="titlegroupcell part" id = "titlegroupcell">`
                    titlegroupcell = titlegroupcell + `<div class="titlegrouptitle">`
                    if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text !== undefined) {
                      titlegroupcell = titlegroupcell + `<span class="edittext" data-path="jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text" data-text="${jsonElement.children[0].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text}"> ${jsonElement.children[0].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text} </span>`
                    }
                    if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.children.length > 0 && jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.children[0].indexmarker.marker !== undefined) {
                      titlegroupcell = titlegroupcell + `<span class="edittext" data-path="${'subsection_attention.children[' + z + '].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.children[0].indexmarker'}" data-text="${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.children[0].indexmarker.marker}"> ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.children[0].indexmarker.marker} </span>`
                    }
                    titlegroupcell = titlegroupcell + `</div>`
                    titlegrouprow = titlegrouprow + titlegroupcell
                    titlegrouprow = titlegrouprow + `</div>`
                    titlegroupbody = titlegroupbody + titlegrouprow
                    titlegroupbody = titlegroupbody + `</div>`
                    titlegroup = titlegroup + titlegroupbody
                    titlegroup = titlegroup + `</div>`
                    sattention = sattention + titlegroup
                  }
                  /** subsection_attention overview 节点  ****/
                  // 视图部分
                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].overview) {
                    var overview = `<div class="overview part" id="${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].overview.id}">`
                    // para,示例
                    var para = `<div class="para"><div class="paratable">`
                    // paratablebody,示例主体
                    var paratablebody = `<div class="paratablebody">`
                    // paratablerow,示例行
                    var paratablerow = `<div class="paratablerow">`
                    // paratablecell,示例单元格
                    var paratablecell = `<div class="paratablecell">`
                    // paratablerow,示例主体
                    var paratabletxt = `<div>`
                    for (let key in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].overview.children) {
                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].overview.children[key].footnote) {
                        paratabletxt = paratabletxt + `<div> ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].overview.children[key].footnote.children[0].p.text} </div>`
                      }
                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].overview.children[key].para) {
                        paratabletxt = paratabletxt + `<div style="background-color: #e6e6e6;" class="paratabletxt edittext"> ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].overview.children[key].para.children[0].paratable.children[0].paratablebody.children[0].paratablerow.children[0].paratablecell.children[0].paratabletxt.text} </div>`
                      }
                    }
                    paratabletxt = paratabletxt + `</div>`
                    paratablecell = paratablecell + paratabletxt
                    paratablecell = paratablecell + `</div>`
                    paratablerow = paratablerow + paratablecell
                    paratablerow = paratablerow + `</div>`
                    paratablebody = paratablebody + paratablerow
                    paratablebody = paratablebody + `</div>`
                    para = para + paratablebody
                    para = para + `</div></div>`
                    overview = overview + para
                    overview = overview + `</div>`
                    sattention = sattention + overview
                  }
                  /**  subsection_attention topic 节点  ****/
                  // 主题
                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic) {
                    var topic = `<div class="topic" id="${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.id}">`
                    for (var y = 0; y < jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children.length; y++) {
                      /**  subsection_attention topic titlegroup 节点 ****/
                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].titlegroup) {
                        var titlegroup1 = `<div class="Topic_title">`
                        var titlegroupbody1 = `<div style="font-size: 16px;display: flex;flex-direction: row;align-items: flex-start;" class="titlegroupbody " id = "titlegroupbody">`
                        var titlegrouprow1 = `<div class="titlegrouprow" id = "titlegrouprow">`
                        var titlegroupcell1 = `<div class="titlegroupcell" id = "titlegroupcell">`
                        titlegroupcell1 = titlegroupcell1 + `<div class="titlegrouptitle edittext part" data-item="${jsonElement}">`
                        if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text !== undefined) {
                          titlegroupcell1 = titlegroupcell1 + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text} </span>`
                        }
                        if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.children.length > 0 && jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.children[0].indexmarker.marker !== undefined) {
                          titlegroupcell1 = titlegroupcell1 + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children.children[y].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.children[0].indexmarker.marker} </span>`
                        }
                        titlegroupcell1 = titlegroupcell1 + `</div>`
                        titlegrouprow1 = titlegrouprow1 + titlegroupcell1
                        titlegrouprow1 = titlegrouprow1 + `</div>`
                        titlegroupbody1 = titlegroupbody1 + titlegrouprow1
                        titlegroupbody1 = titlegroupbody1 + `</div>`
                        titlegroup1 = titlegroup1 + titlegroupbody1
                        titlegroup1 = titlegroup1 + `</div>`
                        topic = topic + titlegroup1
                      }
                      /** subsection_attention topic om_body 节点 ****/
                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body) {
                        for (var x = 0; x < jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children.length; x++) {
                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].title) {
                            var topictitle1 = `<div class="chaptertitle part" style=" font-size: 16px;display: flex;flex-direction: row;align-items: flex-start;">${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].title.text}</div>`
                            topic = topic + topictitle1
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].p) {
                            var topicp1 = `<div class="chaptertitle part" style=" font-size: 16px;display: flex;flex-direction: row;align-items: flex-start;">${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].p.text}</div>`
                            topic = topic + topicp1
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table) {
                            /*
                            // 表标题
                            topic = topic + `<tr>`
                            for (var a = 0; a < jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.cols; a++) {
                              topic = topic + `<th> ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[a].colspec.colname} </th>`
                            }
                            topic = topic + `</tr>`
                            */
                            // 表内容
                            for (var b = 0; b < jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children.length; b++) {
                              if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody !== undefined) {
                                for (var c = 0; c < jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody.children.length; c++) {
                                  var topicbody = `<div class="chaptercontext part" style="font-size: 16px;display: flex;flex-direction: row;align-items: flex-start;justify-content: flex-start;">`
                                  for (var d = 0; d < jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody.children[c].row.children.length; d++) {
                                    if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody.children[c].row.children[d].entry.colname === '1') {
                                      var topicbodyrow = `<div style="display: flex; flex-direction: column; align-items: center;">`
                                      for (var m = 0; m < jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody.children[c].row.children[d].entry.children[0].tbl_fig.children.length; m++) {
                                        if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody.children[c].row.children[d].entry.children[0].tbl_fig.children[m].image) {
                                          // var imgpath1 = 'https://eadmin.sqnetsoft.cn/' + jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody.children[c].row.children[d].entry.children[0].tbl_fig.children[0].image.href.replace(/(\.\.\/)*/g, '').replace(/\.eps$/i, '.jpg')
                                          var imgpath1 = '/static/' + jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody.children[c].row.children[d].entry.children[0].tbl_fig.children[m].image.href.replace(/(\.\.\/)*/g, '').replace(/\.eps$/i, '.jpg')
                                          topicbodyrow = topicbodyrow + `<div style="border: 1px solid #000; "><img src="${imgpath1}" style="width: 50px; height: 30px" alt="图片描述"></div>`
                                        }
                                        if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody.children[c].row.children[d].entry.children[0].tbl_fig.children[m].p) {
                                          topicbodyrow = topicbodyrow + `<div style="font-size: 12px;width:50px;">${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody.children[c].row.children[d].entry.children[0].tbl_fig.children[m].p.text} </div>`
                                        }
                                      }
                                      topicbodyrow = topicbodyrow + `</div>`
                                      topicbody = topicbody + topicbodyrow
                                    }
                                    if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody.children[c].row.children[d].entry.namest) {
                                      var topicnamest = `<div  style="padding-left: 6px; display: flex; flex-direction: column;">`
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody.children[c].row.children[d].entry.children[0].p) {
                                        topicnamest = topicnamest + `<div style="display: flex; flex-direction: row;">`
                                        topicnamest = topicnamest + `<span>${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody.children[c].row.children[d].entry.children[0].p.text}</span>`
                                        for (var f = 0; f < jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody.children[c].row.children[d].entry.children[0].p.children.length; f++) {
                                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody.children[c].row.children[d].entry.children[0].p.children[f].sup) {
                                            topicnamest = topicnamest + `<span class="badge">${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody.children[c].row.children[d].entry.children[0].p.children[f].sup.text}</span>`
                                          }
                                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].table.children[0].tgroup.children[b].tbody.children[c].row.children[d].entry.children[0].p.children[f].xref) {

                                          }
                                        }
                                        topicnamest = topicnamest + `</div>`
                                        topicnamest = topicnamest + `<div>(-->P.${e})</div>`
                                      }
                                      topicnamest = topicnamest + `</div>`
                                      topicbody = topicbody + topicnamest
                                    }
                                  }
                                  topicbody = topicbody + `</div>`
                                  topic = topic + topicbody
                                }
                              }
                            }
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].footnote) {
                            var footnote = `<div class="chapterfootnote footnote part" style="font-size: 16px;display: flex;flex-direction: column;align-items: flex-start;" num="${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].footnote.num}" type="${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].footnote.type}">`
                            if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].footnote.children[0].p !== undefined) {
                              var footnotep = `<div>${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].footnote.num}. ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].footnote.children[0].p.text}</div>`
                              footnote = footnote + footnotep
                            }
                            footnote = footnote + `</div>`
                            topic = topic + footnote
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect) {
                            var paraselect = `<div class="paraselect " style="font-size: 16px;margin: 10px 0 10px 0;">`
                            for (let index in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children) {
                              if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem) {
                                for (let index1 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children) {
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].title) {
                                    var paraselectitemtext = `<div class="paraselectitemtext part">`
                                    paraselectitemtext = paraselectitemtext + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].title.text} </span>`
                                    paraselectitemtext = paraselectitemtext + `</div>`
                                    paraselect = paraselect + paraselectitemtext
                                  }
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig) {
                                    var paraselectitemimg = `<div class="paraselectitemimg part">`
                                    for (let index2 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children) {
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].image) {
                                        var imgpath2 = '/static/' + jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].image.href.replace(/(\.\.\/)*/g, '').replace(/\.eps$/i, '.jpg')
                                        paraselectitemimg = paraselectitemimg + `<div class="paraselectitemimg"><img src="${imgpath2}" style="width: 100%; height: auto" alt="图片描述"></div>`
                                      }
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout) {
                                        for (let index3 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children) {
                                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem) {
                                            var paraselectcalloutitem = `<div class="paraselectcalloutitem" style="font-size: 16px;margin: 5px 0 5px 0;">`
                                            for (let index4 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children) {
                                              if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt) {
                                                var paraselectcalloutitemimg = `<div class="paraselectcalloutitemimg part" style="font-size: 16px;margin: 0;">`
                                                for (let index5 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children) {
                                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index5].symbol) {
                                                    var symbolimgpath = '/static/' + jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index5].symbol.href.replace(/(\.\.\/)*/g, '').replace(/\.eps$/i, '.jpg')
                                                    paraselectcalloutitemimg = paraselectcalloutitemimg + `<img src="${symbolimgpath}" style="width: 26px; height: 26px" alt="图片描述">`
                                                  }
                                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index5].break) {
                                                    paraselectcalloutitemimg = paraselectcalloutitemimg + `<span style="margin-left: 10px;">${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index5].break.text}</span>`
                                                  }
                                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index5].xref) {
                                                  }
                                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index5].sub) {
                                                    paraselectcalloutitemimg = paraselectcalloutitemimg + `<span>${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index5].sub.text}</span>`
                                                  }
                                                }
                                                paraselectcalloutitemimg = paraselectcalloutitemimg + `</div>`
                                                paraselectcalloutitem = paraselectcalloutitem + paraselectcalloutitemimg
                                              }
                                              if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub) {
                                                paraselectcalloutitem = paraselectcalloutitem + `<div style="margin-left:5px;">${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub.text}</div>`
                                                for (let index5 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub.children) {
                                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub.children[index5].xref) {

                                                  }
                                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub.children[index5].text) {
                                                    paraselectcalloutitem = paraselectcalloutitem + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub.children[index5].text}</div>`
                                                  }
                                                }
                                              }
                                            }
                                            paraselectcalloutitem = paraselectcalloutitem + `</div>`
                                            paraselectitemimg = paraselectitemimg + paraselectcalloutitem
                                          }
                                        }
                                      }
                                    }
                                    paraselectitemimg = paraselectitemimg + `</div>`
                                    paraselect = paraselect + paraselectitemimg
                                  }
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].footnote) {
                                    var paraselectitemfootnote = `<div class="paraselectitemfootnote part">`
                                    paraselectitemfootnote = paraselectitemfootnote + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].paraselect.children[index].paraselectitem.children[index1].footnote.children[0].p.text} </span>`
                                    paraselectitemfootnote = paraselectitemfootnote + `</div>`
                                    paraselect = paraselect + paraselectitemfootnote
                                  }
                                }
                              }
                            }
                            paraselect = paraselect + `</div>`
                            topic = topic + paraselect
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig) {
                            var parafig = `<div class="parafig part" style="font-size: 16px;margin: 10px 0 10px 0;">`
                            for (let index2 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children) {
                              var parafigimgdiv = `<div class="parafigimgdiv" style="font-size: 16px;margin: 10px 0 10px 0;">`
                              if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].image) {
                                var imgpath3 = '/static/' + jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].image.href.replace(/(\.\.\/)*/g, '').replace(/\.eps$/i, '.jpg')
                                parafigimgdiv = parafigimgdiv + `<div class="single-column part"><img src="${imgpath3}" style="width: 100%; height: auto" alt="图片描述"></div>`
                              }
                              if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].p) {
                                parafigimgdiv = parafigimgdiv + `<div class="part">${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].p.text}</div>`
                              }
                              if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].callout) {
                                var parafigimgsubdiv = `<div class="parafigimgsubdiv" style="font-size: 16px;margin: 10px 0 10px 0;">`
                                for (let index3 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].callout.children) {
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].callout.children[index3].calloutitem) {
                                    for (let index4 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].callout.children[index3].calloutitem.children) {
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt) {
                                        for (let index6 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children) {
                                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index6].symbol) {
                                            var imgpath4 = '/static/' + jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index6].symbol.href.replace(/(\.\.\/)*/g, '').replace(/\.eps$/i, '.jpg')
                                            parafigimgsubdiv = parafigimgsubdiv + `<div style="border: 1px solid #000; margin-top: 5px;"><img src="${imgpath4}" style="width: 26px; height: 26px;" alt="图片描述"></div>`
                                          }
                                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index6].break) {

                                          }
                                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index6].xref) {

                                          }
                                        }
                                      }
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub) {
                                        parafigimgsubdiv = parafigimgsubdiv + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub.text}</div>`
                                        for (let index5 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub.children) {
                                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub.children[index5].xref) {

                                          }
                                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub.children[index5].text) {
                                            parafigimgsubdiv = parafigimgsubdiv + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub.children[index5].text}</div>`
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                                parafigimgsubdiv = parafigimgsubdiv + `</div>`
                                parafigimgdiv = parafigimgdiv + parafigimgsubdiv
                              }
                              parafigimgdiv = parafigimgdiv + `</div>`
                              parafig = parafig + parafigimgdiv
                            }
                            parafig = parafig + `</div>`
                            topic = topic + parafig
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].note) {
                            window.console.log('newflag',jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].note)
                            var note1 = `<div class="note">`
                            for (let index11 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].note.children[0].note_body.children[0].note_para.children) {
                              window.console.log('newflag',jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].note.children[0].note_body.children[0].note_para.children[index11])
                              if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].note.children[0].note_body.children[0].note_para.children[index11].title) {
                                var topicnotetext3 = `<div class="topicnotetext part">`
                                topicnotetext3 = topicnotetext3 + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].note.children[0].note_body.children[0].note_para.children[index11].title.text} </span>`
                                topicnotetext3 = topicnotetext3 + `</div>`
                                note1 = note1 + topicnotetext3
                              }
                              if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].note.children[0].note_body.children[0].note_para.children[index11].p) {
                                var topicnotep3 = `<div class="topicnotep part">`
                                topicnotep3 = topicnotep3 + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].note.children[0].note_body.children[0].note_para.children[index11].p.text} </span>`
                                topicnotep3 = topicnotep3 + `</div>`
                                note1 = note1 + topicnotep3
                              }
                            }
                            note1 = note1 + `</div>`
                            topic = topic + note1
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention) {
                            var attention1 = `<div class="chaptercontext part" style="font-size: 16px;margin: 10px 0 10px 0;display: flex;flex-direction: column;align-items: flex-start;" class="warningdiv" style="flex-flow: column;"><div class="warningtitle"><img style="width: 20px;height: 20px;margin-right: 5px;" src="https://sqpro.oss-cn-beijing.aliyuncs.com/ecomm/icon/%E8%AD%A6%E5%91%8A.svg" alt="My Icon" />警告</div>`
                            attention1 = attention1 + `<div class="${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention.type}">`
                            for (var g1 = 0; g1 < jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention.children[0].attentiontbl.children[0].attentiontbl_body.children.length; g1++) {
                              for (var h3 = 0; h3 < jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g1].attentiontbl_body_row.children.length; h3++) {
                                for (var hl3 = 0; hl3 < jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g1].attentiontbl_body_row.children[h3].attention_body.children.length; hl3++) {
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g1].attentiontbl_body_row.children[h3].attention_body.children[hl3].attention_mark) {
                                  }
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g1].attentiontbl_body_row.children[h3].attention_body.children[hl3].attention_para) {
                                    for (var l = 0; l < jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g1].attentiontbl_body_row.children[h3].attention_body.children[hl3].attention_para.children.length; l++) {
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g1].attentiontbl_body_row.children[h3].attention_body.children[hl3].attention_para.children[l].title) {
                                        var attentionparatitle3 = `<div class="attention_para_title"><div class="attention_para_titleleft"></div>
                                ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g1].attentiontbl_body_row.children[h3].attention_body.children[hl3].attention_para.children[l].title.text}</div>`
                                        attention1 = attention1 + attentionparatitle3
                                      }
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g1].attentiontbl_body_row.children[h3].attention_body.children[hl3].attention_para.children[l].p) {
                                        var attentionparap3 = `<div class="attention_para_p"> ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g1].attentiontbl_body_row.children[h3].attention_body.children[hl3].attention_para.children[l].p.text}</div>`
                                        alert(attentionparap3)
                                        attention1 = attention1 + attentionparap3
                                        for (let index2 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g1].attentiontbl_body_row.children[h3].attention_body.children[hl3].attention_para.children[l].p.children) {
                                          alert('index2')
                                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g1].attentiontbl_body_row.children[h3].attention_body.children[hl3].attention_para.children[l].p.children[index2].function) {
                                            var attentionparapfun3 = `<div class="attention_para_p"> ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g1].attentiontbl_body_row.children[h3].attention_body.children[hl3].attention_para.children[l].p.children[index2].function.text}</div>`
                                            attention1 = attention1 + attentionparapfun3
                                          }
                                        }
                                      }
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g1].attentiontbl_body_row.children[h3].attention_body.children[hl3].attention_para.children[l].att_list1) {
                                        var attentionparaattlist3 = `<div class="attention_para_p"> ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g1].attentiontbl_body_row.children[h3].attention_body.children[hl3].attention_para.children[l].att_list1.children[0].att_list1_item.children[0].itemtxt.text}</div>`
                                        attention1 = attention1 + attentionparaattlist3
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            attention1 = attention1 + `</div>`
                            attention1 = attention1 + `</div>`
                            topic = topic + attention1
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].step) {
                            var ombodystep = `<div class="ombodystep part"</div>`
                            for (let index2 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].step.children) {
                              if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].step.children[index2].stepitem) {
                                for (let index3 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].step.children[index2].stepitem.children) {
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].step.children[index2].stepitem.children[index3].steptxt) {
                                    ombodystep = ombodystep + `<span>${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].step.children[index2].stepitem.children[index3].steptxt.text}</span>`
                                    for (let index4 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].step.children[index2].stepitem.children[index3].steptxt.children) {
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].step.children[index2].stepitem.children[index3].steptxt.children[index4].symbol) {
                                        var imgpath33 = '/static/' + jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].step.children[index2].stepitem.children[index3].steptxt.children[index4].symbol.href.replace(/(\.\.\/)*/g, '').replace(/\.eps$/i, '.jpg')
                                        ombodystep = ombodystep + `<img src="${imgpath33}" style="width: 30px; height: auto" alt="图片描述">`
                                      }
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].step.children[index2].stepitem.children[index3].steptxt.children[index4].function) {
                                        ombodystep = ombodystep + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].step.children[index2].stepitem.children[index3].steptxt.children[index4].function.text}</div>`
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            ombodystep = ombodystep + `</div>`
                            topic = topic + ombodystep
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].list1) {
                            var ombodylist1 = `<div class="ombodylist1 part"</div>`
                            for (let index2 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].list1.children) {
                              if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].list1.children[index2].list1_item) {
                                for (let index3 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].list1.children[index2].list1_item.children) {
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].list1.children[index2].list1_item.children[index3].itemtxt) {
                                    ombodylist1 = ombodylist1 + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].list1.children[index2].list1_item.children[index3].itemtxt.text}</div>`
                                  }
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].list1.children[index2].list1_item.children[index3].itemtxt_sub) {
                                    ombodylist1 = ombodylist1 + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].list1.children[index2].list1_item.children[index3].itemtxt_sub.text}</div>`
                                  }
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].list1.children[index2].list1_item.children[index3].list2) {
                                    for (let index4 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].list1.children[index2].list1_item.children[index3].list2.children) {
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item) {
                                        for (let index5 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item.children) {
                                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item.children[index5].itemtxt) {
                                            ombodylist1 = ombodylist1 + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item.children[index5].itemtxt.text}</div>`
                                          }
                                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item.children[index5].itemtxt_sub) {
                                            ombodylist1 = ombodylist1 + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].om_body.children[x].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item.children[index5].itemtxt_sub.text}</div>`
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            ombodylist1 = ombodylist1 + `</div>`
                            topic = topic + ombodylist1
                          }
                        }
                      }
                      /** subsection_attention topic note 节点 ****/
                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].note) {
                        window.console.log('newflag',jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].note)
                        var note = `<div class="note">`
                        for (let index11 in jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].note.children[0].note_body.children[0].note_para.children) {
                          window.console.log('newflag',jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].note.children[0].note_body.children[0].note_para.children[index11])
                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].note.children[0].note_body.children[0].note_para.children[index11].title) {
                            var topicnotetext = `<div class="topicnotetext part">`
                            topicnotetext = topicnotetext + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].note.children[0].note_body.children[0].note_para.children[index11].title.text} </span>`
                            topicnotetext = topicnotetext + `</div>`
                            note = note + topicnotetext
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].note.children[0].note_body.children[0].note_para.children[index11].p) {
                            var topicnotep = `<div class="topicnotep part">`
                            topicnotep = topicnotep + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].note.children[0].note_body.children[0].note_para.children[index11].p.text} </span>`
                            topicnotep = topicnotep + `</div>`
                            note = note + topicnotep
                          }
                        }
                        note = note + `</div>`
                        topic = topic + note
                      }
                      /** subsection_attention topic attention 节点 ****/
                      if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].attention !== undefined) {
                        var attention = `<div class="chaptercontext part" style="font-size: 16px;margin: 10px 0 10px 0;display: flex;flex-direction: column;align-items: flex-start;" class="warningdiv" style="flex-flow: column;"><div class="warningtitle"><img style="width: 20px;height: 20px;margin-right: 5px;" src="https://sqpro.oss-cn-beijing.aliyuncs.com/ecomm/icon/%E8%AD%A6%E5%91%8A.svg" alt="My Icon" />警告</div>`
                        attention = attention + `<div class="${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].attention.type}">`
                        for (var g = 0; g < jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].attention.children[0].attentiontbl.children[0].attentiontbl_body.children.length; g++) {
                          for (var h = 0; h < jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g].attentiontbl_body_row.children.length; h++) {
                            for (var hl = 0; hl < jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g].attentiontbl_body_row.children[h].attention_body.children.length; hl++) {
                              if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g].attentiontbl_body_row.children[h].attention_body.children[hl].attention_mark) {
                              }
                              if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g].attentiontbl_body_row.children[h].attention_body.children[hl].attention_para) {
                                for (var l1 = 0; l1 < jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g].attentiontbl_body_row.children[h].attention_body.children[hl].attention_para.children.length; l1++) {
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g].attentiontbl_body_row.children[h].attention_body.children[hl].attention_para.children[l1].title) {
                                    var attentionparatitle = `<div class="attention_para_title"><div class="attention_para_titleleft"></div>
                                ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g].attentiontbl_body_row.children[h].attention_body.children[hl].attention_para.children[l1].title.text}</div>`
                                    attention = attention + attentionparatitle
                                  }
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g].attentiontbl_body_row.children[h].attention_body.children[hl].attention_para.children[l1].p) {
                                    var attentionparap = `<div class="attention_para_p"> ${jsonElement.chapter.children[e].section.children[s].subsection_attention.children[z].topic.children[y].attention.children[0].attentiontbl.children[0].attentiontbl_body.children[g].attentiontbl_body_row.children[h].attention_body.children[hl].attention_para.children[l1].p.text}</div>`
                                    attention = attention + attentionparap
                                  }
                                }
                              }
                            }
                          }
                        }
                        attention = attention + `</div>`
                        attention = attention + `</div>`
                        topic = topic + attention
                      }
                    }
                    topic = topic + `</div>`
                    sattention = sattention + topic
                  }
                }
                sattention = sattention + `</div>`
                section = section + sattention
              }
              if (jsonElement.chapter.children[e].section.children[s].subsection_operation) {
                var sattentionoperation=`<div class="subsection_attention"> </div>`
                for (const key in jsonElement.chapter.children[e].section.children[s].subsection_operation.children) {
                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].titlegroup) {
                    var titlegroupbody11 = `<div class="titlegroupbody titlegrouptitle part" id = "titlegroupbody">`
                    if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text) {
                      titlegroupbody11 = titlegroupbody11 + `<span class="edittext"> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text} </span>`
                    }
                    if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.children[0].indexmarker) {
                      titlegroupbody11 = titlegroupbody11 + `<span class="edittext"> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.children[0].indexmarker.marker} </span>`
                    }
                    titlegroupbody11 = titlegroupbody11 + `</div>`
                    sattentionoperation = sattentionoperation + titlegroupbody11
                  }
                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic) {
                    var sattentionfunctionbase=`<div class="sattentionfunctionbase">`
                    for (const key1 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children) {
                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].titlegroup) {
                        var titlegroupbody111 = `<div class="titlegroupbody titlegrouptitle part titlegrouptitle1" id = "titlegroupbody">`
                        if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text) {
                          titlegroupbody111 = titlegroupbody111 + `<span class="edittext"> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text} </span>`
                        }
                        titlegroupbody111 = titlegroupbody111 + `</div>`
                        sattentionfunctionbase = sattentionfunctionbase + titlegroupbody111
                      }
                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].body) {
                        var titlegroupbody112 = `<div class="titlegroupbody titlegrouptitle part" id = "titlegroupbody">`
                        if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].body.children[0].p) {
                          titlegroupbody112 = titlegroupbody112 + `<span class="edittext"> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].body.children[0].p.text} </span>`
                        }
                        titlegroupbody112 = titlegroupbody112 + `</div>`
                        sattentionfunctionbase = sattentionfunctionbase + titlegroupbody112
                      }
                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation) {
                        for (const key2 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children) {
                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].title) {
                            window.console.log('文本信息',jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].title)
                            if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].title.text) {
                              var basicoperationtitle = `<div class="basicoperationtitle part">`
                              basicoperationtitle = basicoperationtitle + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].title.text} </span>`
                              basicoperationtitle = basicoperationtitle + `</div>`
                              sattentionfunctionbase = sattentionfunctionbase + basicoperationtitle
                            }
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].p) {
                            for (const key3 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].p.children) {
                              if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].p.children[key3].symbol) {
                                var imgpath37 = '/static/' + jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].p.children[key3].symbol.href.replace(/(\.\.\/)*/g, '').replace(/\.eps$/i, '.jpg')
                                sattentionfunctionbase = sattentionfunctionbase + `<img src="${imgpath37}" style="width: 30px; height: auto" alt="图片描述">`
                              }
                            }
                            var basicoperationp = `<div class="basicdescriptionp part">`
                            basicoperationp = basicoperationp + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].p.text} </span>`
                            basicoperationp = basicoperationp + `</div>`
                            sattentionfunctionbase = sattentionfunctionbase + basicoperationp
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].step) {
                            var ombodystep20 = `<div class="ombodystep part"</div>`
                            for (let index2 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].step.children) {
                              if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].step.children[index2].stepitem) {
                                for (let index3 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].step.children[index2].stepitem.children) {
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].step.children[index2].stepitem.children[index3].steptxt) {
                                    ombodystep20 = ombodystep20 + `<span>${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].step.children[index2].stepitem.children[index3].steptxt.text}</span>`
                                    for (let index4 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].step.children[index2].stepitem.children[index3].steptxt.children) {
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].step.children[index2].stepitem.children[index3].steptxt.children[index4].symbol) {
                                        var imgpath34 = '/static/' + jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].step.children[index2].stepitem.children[index3].steptxt.children[index4].symbol.href.replace(/(\.\.\/)*/g, '').replace(/\.eps$/i, '.jpg')
                                        ombodystep20 = ombodystep20 + `<img src="${imgpath34}" style="width: 30px; height: auto" alt="图片描述">`
                                      }
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].step.children[index2].stepitem.children[index3].steptxt.children[index4].function) {
                                        ombodystep20 = ombodystep20 + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].step.children[index2].stepitem.children[index3].steptxt.children[index4].function.text}</div>`
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            ombodystep20 = ombodystep20 + `</div>`
                            sattentionfunctionbase = sattentionfunctionbase + ombodystep20
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].list1) {
                            var ombodylist20 = `<div class="ombodylist1 part"</div>`
                            for (let index2 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].list1.children) {
                              if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].list1.children[index2].list1_item) {
                                for (let index3 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].list1.children[index2].list1_item.children) {
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].list1.children[index2].list1_item.children[index3].itemtxt) {
                                    ombodylist20 = ombodylist20 + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].list1.children[index2].list1_item.children[index3].itemtxt.text}</div>`
                                  }
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].list1.children[index2].list1_item.children[index3].itemtxt_sub) {
                                    ombodylist20 = ombodylist20 + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].list1.children[index2].list1_item.children[index3].itemtxt_sub.text}</div>`
                                  }
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].list1.children[index2].list1_item.children[index3].list2) {
                                    for (let index4 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].list1.children[index2].list1_item.children[index3].list2.children) {
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item) {
                                        for (let index5 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item.children) {
                                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item.children[index5].itemtxt) {
                                            ombodylist20 = ombodylist20 + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item.children[index5].itemtxt.text}</div>`
                                          }
                                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item.children[index5].itemtxt_sub) {
                                            ombodylist20 = ombodylist20 + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_operation.children[key2].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item.children[index5].itemtxt_sub.text}</div>`
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            ombodylist20 = ombodylist20 + `</div>`
                            sattentionfunctionbase = sattentionfunctionbase + ombodylist20
                          }
                        }
                      }
                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description) {
                        for (const key2 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children) {
                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].title) {
                            if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].title.text) {
                              var basicdescriptiontitle = `<div class="basicdescriptiontitle part">`
                              basicdescriptiontitle = basicdescriptiontitle + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].title.text} </span>`
                              basicdescriptiontitle = basicdescriptiontitle + `</div>`
                              sattentionfunctionbase = sattentionfunctionbase + basicdescriptiontitle
                            }
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].p) {
                            var basicdescriptionp = `<div class="basicdescriptionp part">`
                            basicdescriptionp = basicdescriptionp + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].p.text} </span>`
                            basicdescriptionp = basicdescriptionp + `</div>`
                            sattentionfunctionbase = sattentionfunctionbase + basicdescriptionp
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].step) {
                            var ombodystep30 = `<div class="ombodystep part"</div>`
                            for (let index2 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].step.children) {
                              if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].step.children[index2].stepitem) {
                                for (let index3 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].step.children[index2].stepitem.children) {
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].step.children[index2].stepitem.children[index3].steptxt) {
                                    ombodystep30 = ombodystep30 + `<span>${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].step.children[index2].stepitem.children[index3].steptxt.text}</span>`
                                    for (let index4 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].step.children[index2].stepitem.children[index3].steptxt.children) {
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].step.children[index2].stepitem.children[index3].steptxt.children[index4].symbol) {
                                        var imgpath38 = '/static/' + jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].step.children[index2].stepitem.children[index3].steptxt.children[index4].symbol.href.replace(/(\.\.\/)*/g, '').replace(/\.eps$/i, '.jpg')
                                        ombodystep30 = ombodystep30 + `<img src="${imgpath38}" style="width: 30px; height: auto" alt="图片描述">`
                                      }
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].step.children[index2].stepitem.children[index3].steptxt.children[index4].function) {
                                        ombodystep20 = ombodystep20 + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].step.children[index2].stepitem.children[index3].steptxt.children[index4].function.text}</div>`
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            ombodystep30 = ombodystep30 + `</div>`
                            sattentionfunctionbase = sattentionfunctionbase + ombodystep30
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect) {
                            var paraselect11 = `<div class="paraselect" style="font-size: 16px;margin: 10px 0 10px 0;">`
                            for (let index in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children) {
                              if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem) {
                                for (let index1 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children) {
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].title) {
                                    var paraselectitemtext1 = `<div class="paraselectitemtext part">`
                                    paraselectitemtext1 = paraselectitemtext1 + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].title.text} </span>`
                                    paraselectitemtext1 = paraselectitemtext1 + `</div>`
                                    paraselect11 = paraselect11 + paraselectitemtext1
                                  }
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig) {
                                    var paraselectitemimg1 = `<div class="paraselectitemtext part">`
                                    for (let index2 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children) {
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].image) {
                                        var imgpath21 = '/static/' + jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].image.href.replace(/(\.\.\/)*/g, '').replace(/\.eps$/i, '.jpg')
                                        paraselectitemimg1 = paraselectitemimg1 + `<div style="border: 1px solid #000; margin-top: 5px;"><img src="${imgpath21}" style="width: 100%; height: auto" alt="图片描述"></div>`
                                      }
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout) {
                                        for (let index3 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children) {
                                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem) {
                                            for (let index4 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children) {
                                              if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt) {
                                                var paraselectcalloutitemimg1 = `<div class="paraselectcalloutitemimg" style="font-size: 16px;margin: 0;">`
                                                for (let index5 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children) {
                                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index5].symbol) {
                                                    var symbolimgpath2 = '/static/' + jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index5].symbol.href.replace(/(\.\.\/)*/g, '').replace(/\.eps$/i, '.jpg')
                                                    paraselectcalloutitemimg1 = paraselectcalloutitemimg1 + `<img src="${symbolimgpath2}" style="width: 26px; height: 26px" alt="图片描述">`
                                                  }
                                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index5].break) {
                                                    paraselectcalloutitemimg1 = paraselectcalloutitemimg1 + `<span style="margin-left: 10px;">${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index5].break.text}</span>`
                                                  }
                                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index5].xref) {
                                                  }
                                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index5].sub) {
                                                    paraselectcalloutitemimg1 = paraselectcalloutitemimg1 + `<span>${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt.children[index5].sub.text}</span>`
                                                  }
                                                }
                                                paraselectcalloutitemimg1 = paraselectcalloutitemimg1 + `</div>`
                                                paraselectitemimg1 = paraselectitemimg1 + paraselectcalloutitemimg1
                                              }
                                              if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub) {
                                                paraselectitemimg1 = paraselectitemimg1 + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub.text}</div>`
                                                for (let index5 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub.children) {
                                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub.children[index5].xref) {

                                                  }
                                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub.children[index5].text) {
                                                    paraselectitemimg1 = paraselectitemimg1 + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].callouttxt_sub.children[index5].text}</div>`
                                                  }
                                                }
                                              }
                                              if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].calloutlist) {
                                                for (let index5 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].calloutlist.children) {
                                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].calloutlist.children[index5].calloutlist_item) {
                                                    for (let index6 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].calloutlist.children[index5].calloutlist_item.children) {
                                                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].calloutlist.children[index5].calloutlist_item.children[index6].itemtxt) {
                                                        var calloutlisttxt11 = `<div class="calloutlisttxt part">`
                                                        calloutlisttxt11 = calloutlisttxt11 + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].calloutlist.children[index5].calloutlist_item.children[index6].itemtxt.text} </span>`
                                                        calloutlisttxt11 = calloutlisttxt11 + `</div>`
                                                        paraselectitemimg1 = paraselectitemimg1 + calloutlisttxt11
                                                        for (let index7 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].calloutlist.children[index5].calloutlist_item.children[index6].itemtxt.children) {
                                                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].fig.children[index2].callout.children[index3].calloutitem.children[index4].calloutlist.children[index5].calloutlist_item.children[index6].itemtxt.children[index7].xref) {

                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                    paraselectitemimg1 = paraselectitemimg1 + `</div>`
                                    paraselect11 = paraselect11 + paraselectitemimg1
                                  }
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].footnote) {
                                    var paraselectitemfootnote1 = `<div class="paraselectitemfootnote part">`
                                    paraselectitemfootnote1 = paraselectitemfootnote1 + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].paraselect.children[index].paraselectitem.children[index1].footnote.children[0].p.text} </span>`
                                    paraselectitemfootnote1 = paraselectitemfootnote1 + `</div>`
                                    paraselect11 = paraselect11 + paraselectitemfootnote1
                                  }
                                }
                              }
                            }
                            paraselect11 = paraselect11 + `</div>`
                            sattentionfunctionbase = sattentionfunctionbase + paraselect11
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].list1) {
                            var ombodylist30 = `<div class="ombodylist1 part"</div>`
                            for (let index2 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].list1.children) {
                              if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].list1.children[index2].list1_item) {
                                for (let index3 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].list1.children[index2].list1_item.children) {
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].list1.children[index2].list1_item.children[index3].itemtxt) {
                                    ombodylist30 = ombodylist30 + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].list1.children[index2].list1_item.children[index3].itemtxt.text}</div>`
                                  }
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].list1.children[index2].list1_item.children[index3].itemtxt_sub) {
                                    ombodylist30 = ombodylist30 + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].list1.children[index2].list1_item.children[index3].itemtxt_sub.text}</div>`
                                  }
                                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].list1.children[index2].list1_item.children[index3].list2) {
                                    for (let index4 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].list1.children[index2].list1_item.children[index3].list2.children) {
                                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item) {
                                        for (let index5 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item.children) {
                                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item.children[index5].itemtxt) {
                                            ombodylist20 = ombodylist20 + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item.children[index5].itemtxt.text}</div>`
                                          }
                                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item.children[index5].itemtxt_sub) {
                                            ombodylist20 = ombodylist20 + `<div>${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].basic_description.children[key2].list1.children[index2].list1_item.children[index3].list2.children[index4].list2_item.children[index5].itemtxt_sub.text}</div>`
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            ombodylist30 = ombodylist30 + `</div>`
                            sattentionfunctionbase = sattentionfunctionbase + ombodylist30
                          }
                        }
                      }
                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].note) {
                        var note11 = `<div class="note">`
                        for (let index11 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].note.children[0].note_body.children[0].note_para.children) {
                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].note.children[0].note_body.children[0].note_para.children[index11].title) {
                            var topicnotetext1 = `<div class="topicnotetext part">`
                            topicnotetext1 = topicnotetext1 + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].note.children[0].note_body.children[0].note_para.children[index11].title.text} </span>`
                            topicnotetext1 = topicnotetext1 + `</div>`
                            note11 = note11 + topicnotetext1
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].note.children[0].note_body.children[0].note_para.children[index11].p) {
                            var topicnotep1 = `<div class="topicnotep part">`
                            topicnotep1 = topicnotep1 + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].note.children[0].note_body.children[0].note_para.children[index11].p.text} </span>`
                            topicnotep1 = topicnotep1 + `</div>`
                            note11 = note11 + topicnotep1
                          }
                        }
                        note11 = note11 + `</div>`
                        sattentionfunctionbase = sattentionfunctionbase + note11
                      }
                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_basic.children[key1].attention) {

                      }
                    }
                    sattentionfunctionbase = sattentionfunctionbase + `</div>`
                    sattentionoperation = sattentionoperation + sattentionfunctionbase
                  }
                  if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_advanced) {
                    var sattentionfunctionadvanced=`<div class="sattentionfunctionadvanced">`
                    for (const key1 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_advanced.children) {
                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_advanced.children[key1].titlegroup) {
                        var titlegroupbody113 = `<div class="titlegroupbody titlegrouptitle part" id = "titlegroupbody">`
                        if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_advanced.children[key1].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text) {
                          titlegroupbody113 = titlegroupbody113 + `<span class="edittext"> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_advanced.children[key1].titlegroup.children[0].titlegroupbody.children[0].titlegrouprow.children[0].titlegroupcell.children[0].title.text} </span>`
                        }
                        titlegroupbody113 = titlegroupbody113 + `</div>`
                        sattentionfunctionadvanced = sattentionfunctionadvanced + titlegroupbody113
                      }
                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_advanced.children[key1].body) {
                        var titlegroupbody114 = `<div class="titlegroupbody titlegrouptitle part" id = "titlegroupbody">`
                        if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_advanced.children[key1].body.children[0].p) {
                          titlegroupbody114 = titlegroupbody114 + `<span class="edittext"> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_advanced.children[key1].body.children[0].p.text} </span>`
                        }
                        titlegroupbody114 = titlegroupbody114 + `</div>`
                        sattentionfunctionadvanced = sattentionfunctionadvanced + titlegroupbody114
                      }
                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_advanced.children[key1].note) {
                        var note21 = `<div class="note">`
                        for (let index11 in jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_advanced.children[key1].note.children[0].note_body.children[0].note_para.children) {
                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_advanced.children[key1].note.children[0].note_body.children[0].note_para.children[index11].title) {
                            var topicnotetext21 = `<div class="topicnotetext part">`
                            topicnotetext21 = topicnotetext21 + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_advanced.children[key1].note.children[0].note_body.children[0].note_para.children[index11].title.text} </span>`
                            topicnotetext21 = topicnotetext21 + `</div>`
                            note21 = note21 + topicnotetext21
                          }
                          if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_advanced.children[key1].note.children[0].note_body.children[0].note_para.children[index11].p) {
                            var topicnotep21 = `<div class="topicnotep part">`
                            topicnotep21 = topicnotep21 + `<span> ${jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_advanced.children[key1].note.children[0].note_body.children[0].note_para.children[index11].p.text} </span>`
                            topicnotep21 = topicnotep21 + `</div>`
                            note21 = note21 + topicnotep21
                          }
                        }
                        note21 = note21 + `</div>`
                        sattentionfunctionadvanced = sattentionfunctionadvanced + note21
                      }
                      if (jsonElement.chapter.children[e].section.children[s].subsection_operation.children[key].topic_function_advanced.children[key1].attention) {

                      }
                    }
                    sattentionfunctionadvanced = sattentionfunctionadvanced + `</div>`
                    sattentionoperation = sattentionoperation + sattentionfunctionadvanced
                  }
                }
                sattentionoperation = sattentionoperation + `</div>`
                section = section + sattentionoperation
              }
              section = section + `</div>`
              chapter = chapter + section
            }
          }
        }
        chapter= chapter + `</div>`
        return chapter
      }
      let innerHtml = '';
      for (const key in jsonElement) {
        innerHtml += jsonToHtml(jsonElement[key]);
      }
      return innerHtml;
    } else {
      return '';
    }
  }
</script>

<style>
  @media print {
    #page-header, #page-footer {
      display: block;
    }
    body {
      margin-top: 30px; /* 为页眉腾出空间 */
      margin-bottom: 30px; /* 为页脚腾出空间 */
    }
  }

  #page-header {
    text-align: center;
    font-weight: bold;
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
  }

  #page-footer {
    text-align: center;
    font-size: 12px;
    border-top: 1px solid #ccc;
    padding-top: 5px;
  }
  .paraselect {
    display: flex;
    flex-direction: column;
  }
  .chapter {
    height: 660px;
    overflow-y: auto;
  }
  .titlecss {
    font-size: 24px;
  }
  /* 角标 */
  .badge {
    position: relative;
    display: inline-block;
    color: #000;
    font-size: 10px;
  }

  .badge::after {
    top: 0;
    right: 0;
    transform: translateX(-50%);
    position: absolute;
  }

  .split-content {
    display: block;
    height: 660px;
    -webkit-column-count: 2; /* Chrome, Safari, Opera */
    -moz-column-count: 2;    /* Firefox */
    column-count: 2;
    -webkit-column-gap: 20px; /* Chrome, Safari, Opera */
    -moz-column-gap: 20px;    /* Firefox */
    column-gap: 20px;
    -webkit-column-break-inside: avoid; /* 避免在元素内部进行列中断（针对webkit内核浏览器，如Chrome、Safari等） */
    page-break-inside: avoid; /* 避免在元素内部进行分页（通用属性，提高兼容性） */
    break-inside: avoid; /* 新的标准属性，用于避免在元素内部打断，增强兼容性 */
    margin-bottom: 50px; /* 每个拆分后的div之间添加一点间距，美观性考虑 */
  }
  .chaptercontext {
    word-wrap:break-word;
    word-break: break-all !important;
  }
  .attention_para_p {
    word-wrap:break-word;
    word-break: break-all !important;
    line-height: 1.5
  }
  .titlegroupbody,.footnote,.warningdiv {
    margin-bottom: 0px; /* 适当增加各部分之间的间距，让展示更清晰美观 */
  }
  .titlegrouptitle {
    margin-top: 10px;
    width: 100%;
    background-color: #656565;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    padding: 6px;
  }
  .halfdiv {
    width: 28%;
  }
  .titlegrouptitle1 {
    margin-top: 10px;
    background-color: #d1d1d1;
    color: #000;
    font-size: 18px;
    font-weight: 600;
    padding: 6px;
    border-left: 10px solid #656565;
  }
  .Topic_title .titlegrouptitle {
    margin-top: 10px;
    width: 100%;
    background-color: #d1d1d1;
    color: #000;
    font-size: 18px;
    font-weight: 600;
    padding: 6px;
    border-left: 10px solid #656565;
  }
  .Topic_title .titlegroupbody {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .split-content .column {
    column-count: 2; /* 保持两列布局 */
    column-gap: 20px; /* 两列之间的间距 */
    -webkit-column-break-inside: avoid; /* 避免在元素内部进行列中断（针对webkit内核浏览器，如Chrome、Safari等） */
    page-break-inside: avoid; /* 避免在元素内部进行分页（通用属性，提高兼容性） */
    break-inside: avoid; /* 新的标准属性，用于避免在元素内部打断，增强兼容性 */
  }
  .split-content .single-column {
    column-count: 1; /* 单列布局 */
  }
  .overview {
    margin-top: 10px;
    padding: 6px;
    font-size: 18px;
    font-weight: 600;
  }
  .titlegrouprow {
    width: 100%;
  }
  .subsection_attention {
    width: 100%;
    transition: opacity 0.5s ease-in-out;
    opacity: 1;
  }
  .SubSection_title {
    color: #000;
    font-size:18px;
    transition: opacity 0.5s ease-in-out;
    opacity: 1;
  }
  .Topic_title {
    width: 100%;
    color: #000;
    font-size:18px;
    transition: opacity 0.5s ease-in-out;
    opacity: 1;
  }
  .page-break {
    background-color: #d58512;
    page-break-before: always; /* 在分页标记前强制分页 */
    height: 20px; /* 高度设为0，不占据实际空间 */
    clear: both; /* 清除浮动等，保证分页位置准确 */
  }
  .warningdiv {
    border: 1px solid #ff00ff;
    display: flex;
    flex-direction: column;
  }
  .warning {
    padding: 8px;
    border: 1px solid #ff00ff;
  }
  .warningtitle {
    width: 100%;
    background-color: #ffccff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    padding: 4px;
  }
  .attention_para_titleleft {
    width: 16px;
    height: 16px;
    background-color: #ff00ff;
    margin-right: 5px;
  }
  .attention_para_title {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: 600;
    margin-bottom: 5px;
  }
  .om_body {
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
  }
  .footnote {
    font-size: 16px;
  }
  .overview {
    width: 100%;
    transition: opacity 0.5s ease-in-out;
    opacity: 1;
  }
  .overview:hover {
    animation: blink 1s infinite;
  }
  .paraselectcalloutitem {
    display: flex;
    flex-direction: column;
  }
  .paraselectcalloutitemimg {
    display: flex;
    flex-direction: row;
  }
  .parafigimgdiv {
    display: flex;
    flex-direction: column;
  }
  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pro/ft/FTPro.vue